webpackJsonp([17],{

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AsideToggler_vue__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf54bfc2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AsideToggler_vue__ = __webpack_require__(219);
function injectStyle (ssrContext) {
  __webpack_require__(217)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AsideToggler_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf54bfc2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AsideToggler_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(44);
/**
 * A navigation guard helper function
 *
 * @param {route} toRoute - the route object that is about to be navigated to
 * @param {function} callback - a callback function that receive route object
 *                              as its first parameter. i.e. next() / route.push()
 */

// TODO: Look into make this more modular, so that more guards can be added without making this thing more complex
/* harmony default export */ __webpack_exports__["a"] = (function (toRoute, callback) {
  var navigate = function navigate(incoming) {
    if (incoming == null) callback();else if (toRoute.path === (incoming.path || incoming)) callback(); // prevent infinite self redirection loop
    else callback(incoming);
  };

  // Always navigate to guest route without checking
  if (toRoute.meta.guest) return navigate();

  // Otherwise, check for authorisation
  // Router will use localStorage to check is the user is authorized to enter
  var hasUserLogin = !!localStorage.getItem('access_token');
  // Guard against unauthorized access
  if (!hasUserLogin) {
    return navigate({
      path: '/login',
      query: {
        redirect: toRoute.fullPath,
        art_intent: 'nav-guarded'
      }
    });
  }

  // Here, user should have successfully login.
  // Check for sign up flow
  var needSignupFlow = __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.account.needSignup;

  // Perform redirection only when needSignupFlow is ready
  if (needSignupFlow !== null) {
    // Find a suitable place for the user (they can land in any of these step)
    if (needSignupFlow === true) {
      if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.account.shouldAskForVerification || __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.account.shouldAskForAddingEmail) {
        return navigate('/signup/email');
      } else if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.account.shouldAskForAgreement) {
        return navigate('/signup/agreement');
      } else if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.account.shouldAskForSignup) {
        return navigate('/signup');
      } else {
        return navigate('/signup');
      }
      // If user has no need to sign up, but still navigate to signup, kick them back to profile
    } else if (toRoute.path.startsWith('/signup')) {
      return navigate('/profile');
    }
  }

  return navigate();
});

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_semver__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_semver__);
/* global BAKED_APPLICATION_VERSION */


var applicationVersion = "1.13.8";
var parsedSemver = __WEBPACK_IMPORTED_MODULE_0_semver___default.a.parse(applicationVersion);

/* harmony default export */ __webpack_exports__["a"] = ({
  version: applicationVersion,
  reportVersion: function reportVersion() {
    /* eslint no-console: 0 */
    console.log('Viddsee Creator version: ' + applicationVersion + ' (' + "production" + ')');
  },
  injectVersion: function injectVersion() {
    var injectionTarget = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

    var _ref = parsedSemver || {},
        _ref$major = _ref.major,
        major = _ref$major === undefined ? 0 : _ref$major,
        _ref$minor = _ref.minor,
        minor = _ref$minor === undefined ? 0 : _ref$minor,
        _ref$patch = _ref.patch,
        patch = _ref$patch === undefined ? 0 : _ref$patch;

    var versionSum = 0 + major * 1000000 + minor * 1000 + patch * 1;

    injectionTarget.version = {
      version: applicationVersion,
      versionSum: versionSum
    };
  }
});

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_magic_values__ = __webpack_require__(199);


/* harmony default export */ __webpack_exports__["a"] = ({
  DURATION: {
    SHORT: 5 * __WEBPACK_IMPORTED_MODULE_0__config_magic_values__["c" /* SECOND_IN_MS */],
    MEDIUM: 12 * __WEBPACK_IMPORTED_MODULE_0__config_magic_values__["c" /* SECOND_IN_MS */],
    LONG: 25 * __WEBPACK_IMPORTED_MODULE_0__config_magic_values__["c" /* SECOND_IN_MS */],
    FOREVER: 0
  }
});

/***/ }),

/***/ 182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);


// Rules ordered by the order of the submission children

// TODO: Ponder: Should steps be linked by index of array? This seems fragile
// and will break if the order of the steps were changed. Also how can the
// children know what is its own index?


var isEmpty = function isEmpty(data) {
  switch (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data)) {
    case 'number':
    case 'boolean':
      return false;
    case 'string':
      return !data;
    case 'object':
      return __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(data);
    default:
      return true;
  }
};

var makeResult = function makeResult(required, error) {
  if (!required) return null;
  return {
    required: 1,
    completed: error ? 0 : 1,
    error: error
  };
};

var validator = {
  required: function required(key, rules, value) {
    var requiredRule = rules.find(function (rule) {
      return rule.required;
    });

    if (requiredRule) {
      if (!isEmpty(value)) {
        return makeResult(true);
      } else {
        var message = requiredRule.message || key + ' is required';
        return makeResult(true, message);
      }
    }
    return makeResult();
  }
};

var stepsRules = [{
  video_file_url: [],
  video_file_url_alt: []
}, {
  // Basic
  title: [{ required: true }],
  language: [{ required: true }],
  description_long: [{ required: true, message: 'synopsis is required' }],
  // Alternate language
  alt_title: [{ required: false }],
  alt_language: [{ required: false }],
  alt_description_long: [{ required: false }],
  // Other
  year: [{ required: true }, {
    validator: function validator(rule, value, callback) {
      var receivedYear = value.getYear();
      var todayYear = new Date().getYear();
      if (receivedYear > todayYear) {
        callback('Production year shouldn\'t be set in the future');
      } else {
        callback();
      }
    },
    trigger: 'blur'
  }],
  country: [{ required: true }],
  directors: [{ required: false }],
  // Video attributes
  genres: [{ required: true, message: 'please choose or enter the genres of the film' }],
  topics: [{ required: false }],
  meta_tags: [{ required: false }]
}, {
  collaborators: []
}, {
  image: [],
  attachment: []
}, {}, {}];

var managers = [function (rules, submission) {
  var propKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(rules);
  var hasUpload = propKeys.some(function (key) {
    return !!submission[key];
  });

  return [makeResult(true, hasUpload ? null : 'Video file or url is not updated yet.')];
}, function (rules, submission) {
  var propKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(rules);
  var result = propKeys.map(function (key) {
    return validator.required(key, rules[key], submission[key]);
  });
  return result;
}, function (rules, submission) {
  var hasDirector = !!submission.collaborators.filter(function (collaborator) {
    return collaborator.role === 'director';
  }).length;
  return [makeResult(true, hasDirector ? null : 'Please add at least 1 director in Collaborator')];
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  rules: stepsRules,
  managers: managers
});

/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_webcall__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__versionReporter__ = __webpack_require__(176);








var LOG_LEVEL = {
  OFF: 0,
  WARN: 1,
  ERROR: 2,
  ALL: 3
};

var TRACKER_TYPE = {
  error: 'error',
  usage: 'usage'
};

var track = function track(trackerType, message, data) {
  // TODO: Check and make sure that user as internet access.
  // If no internet, queue tracker into localStorage, to be sent when he next open the page
  // If yes, send tracker directly

  if (!navigator.onLine) return null; // TODO: Is not online, don't track now, otherwise a infinite loop will happen;

  var tracker = {
    activity_type: 'creator_' + trackerType,
    product: 'creator',
    user_agent: navigator.userAgent,
    user_id: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.account.blob ? __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.account.blob.id : false,
    params: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
      message: message,
      debug: {
        version: __WEBPACK_IMPORTED_MODULE_6__versionReporter__["a" /* default */].version,
        path: window.location.href,
        store: {
          layout: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.layout,
          uploadQueue: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.uploadQueue,
          submission: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.submission)
        },
        window: {
          x: innerHeight,
          y: innerWidth
        }
      }
    }, data))
  };

  return __WEBPACK_IMPORTED_MODULE_4__libs_webcall__["a" /* default */].support.log(tracker);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  logLevel:  true ? LOG_LEVEL.OFF : LOG_LEVEL.ALL,
  warn: function warn(message) {
    /* eslint no-console: 0 */
    console.warn(message);
  },
  error: function error(message) {
    /* eslint no-console: 0 */
    console.error(message);
  },
  errorHandler: function errorHandler(error, vm, info) {
    track(TRACKER_TYPE.error, info, {
      error: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(error, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default()(error))
    });

    throw error;
  },

  track: {
    error: function error(title, message, data) {
      return track(TRACKER_TYPE.error, message, data);
    },
    info: function info(title, message, data) {
      return track(TRACKER_TYPE.info, message, data);
    }
  }
});

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardCol_vue__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36045a48_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardCol_vue__ = __webpack_require__(406);
function injectStyle (ssrContext) {
  __webpack_require__(404)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardCol_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36045a48_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardCol_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 196:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]());

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SupportButton_vue__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6590572a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SupportButton_vue__ = __webpack_require__(229);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SupportButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6590572a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SupportButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);

var STATUS = {
  ERROR: -1,
  SAVED: 0,
  SAVING: 1
};

// TODO: Currently only support 1 activity at a time
var networkActivity = {
  namespaced: true,
  state: {
    status: STATUS.SAVED,
    STATUS: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(STATUS)
  },
  getters: {},
  mutations: {
    success: function success(state) {
      state.status = STATUS.SAVED;
    },
    error: function error(state) {
      state.status = STATUS.ERROR;
    },
    loading: function loading(state) {
      state.status = STATUS.SAVING;
    },
    updateStatus: function updateStatus(state, status) {
      state.status = status;
    }
  },
  actions: {}
};

/* harmony default export */ __webpack_exports__["a"] = (networkActivity);

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NGINX_UPLOAD_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ONE_MEGABYTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SECOND_IN_MS; });
var NGINX_UPLOAD_LIMIT = 5000000;
var ONE_MEGABYTES = 1000000;
var SECOND_IN_MS = 1000;

/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Steps components
var FilmDetail = function FilmDetail() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 517));
};
var CollaboratorDetails = function CollaboratorDetails() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 518));
};
// const FilesMedia = () => import('./steps/FilesMedia');
var NewFilesMedia = function NewFilesMedia() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 519));
};
var AdditionalDetail = function AdditionalDetail() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 520));
};
var Terms = function Terms() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 514));
};
var VideoUpload = function VideoUpload() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 515));
};

/* harmony default export */ __webpack_exports__["a"] = ([{ label: '1. Upload',
  component: VideoUpload
}, {
  label: '2. Details',
  component: FilmDetail
}, {
  label: '3. Collaborators',
  component: CollaboratorDetails
}, {
  label: '4. Files',
  // component: FilesMedia,
  component: NewFilesMedia
}, {
  label: '5. Additional',
  component: AdditionalDetail
}, {
  label: '6. Terms',
  component: Terms
}]);

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_versionReporter__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_debugLogger__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services__ = __webpack_require__(510);
var _this = this;

// Vue specific modules








__WEBPACK_IMPORTED_MODULE_4__utils_versionReporter__["a" /* default */].reportVersion();
__WEBPACK_IMPORTED_MODULE_4__utils_versionReporter__["a" /* default */].injectVersion(window);
__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('account/initialiseAccount');
__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('agreement/initialise');

// Vue render initialisation
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
// Set up sw communication
window.displaySWUpdateDialogue = function () {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$msgbox({
    title: 'Update available',
    message: 'An update is available for Viddsee Creator. Refresh the page to get the latest update.',
    showCancelButton: true,
    confirmButtonText: 'Refresh',
    cancelButtonText: 'Cancel'
  }).then(function (action) {
    if (action === 'confirm') {
      location.reload();
    }
  }).catch(function () {
    __WEBPACK_IMPORTED_MODULE_5__utils_debugLogger__["a" /* default */].track.error('User refused to refresh page when received new service worker.');
    window.userRefusedToUpdate = true;
  });
};

// Set up error logging service
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.errorHandler = __WEBPACK_IMPORTED_MODULE_5__utils_debugLogger__["a" /* default */].errorHandler;
window.addEventListener('unhandledrejection', function (event) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.errorHandler.call(_this, event, _this, event.reason);
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd26cd6c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(496);
function injectStyle (ssrContext) {
  __webpack_require__(206)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd26cd6c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 206:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Aside__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Utilities_Dialogue_SupportNew__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_navGuard__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_onlineWatcher__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_notify_constants__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Shared__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_elementUiImporter__ = __webpack_require__(427);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// Utilities





// Element UI


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    'vs-navigation': __WEBPACK_IMPORTED_MODULE_0__components_Navigation__["a" /* default */],
    'vs-aside': __WEBPACK_IMPORTED_MODULE_1__components_Aside__["a" /* default */],
    SupportDialogue: __WEBPACK_IMPORTED_MODULE_2__components_Utilities_Dialogue_SupportNew__["a" /* default */]
  },
  data: function data() {
    return {
      isAccountReady: false,
      createWatcherInstance: null
    };
  },

  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.state.account.isAuthenticated;
    },
    isAccountReadyState: function isAccountReadyState() {
      return this.isAuthenticated !== null && this.$store.state.account.needSignup !== null;
    },
    layout: function layout() {
      return this.$store.state.layout;
    }
  },
  watch: {
    isAuthenticated: function isAuthenticated(status) {
      var _this = this;

      if (status === false) {
        // Sync login router with account state
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_navGuard__["a" /* default */])(this.$route, function (path) {
          if (path != null) _this.$router.push(path);
        }, 'app.vue');
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var offlineWatcherNotification = null;
    this.createWatcherInstance = Object(__WEBPACK_IMPORTED_MODULE_4__libs_onlineWatcher__["a" /* default */])({
      onOffline: function onOffline() {
        offlineWatcherNotification = _this2.$notify.warning({
          title: 'No Internet',
          message: 'Seems like you\'re offline, please check your internet connection',
          showClose: false,
          duration: __WEBPACK_IMPORTED_MODULE_5__config_notify_constants__["a" /* default */].DURATION.FOREVER
        });
      },
      onOnline: function onOnline() {
        if (offlineWatcherNotification) offlineWatcherNotification.close();
        offlineWatcherNotification = null;
      }
    });

    // Warn closing of tab if an uploading is still on going
    window.addEventListener('beforeunload', function (e) {
      var uploadInProgress = _this2.$store.state.uploadQueue.activeCounter > 0;

      if (uploadInProgress) {
        e.returnValue = true;
        return true;
      }
      return null;
    });
    // TODO: Urgent! setTimeout is not deterministic and is hardware dependent.
    //       Need to find a way to resolve this problem.
    //       It appear that Store updates is faster than route changing.
    //       It is possible that this.$route is still pointing to the base '/' route
    //       causing navguard to navigation to '/'.
    var counter = 0;
    var interval = setInterval(function () {
      if (_this2.isAccountReadyState) {
        counter += 1;
        if (_this2.$route.path !== '/') {
          clearInterval(interval);
          _this2.isAccountReady = true;
          // Sync login router with account state
          Object(__WEBPACK_IMPORTED_MODULE_3__utils_navGuard__["a" /* default */])(_this2.$route, function (path) {
            if (path != null) _this2.$router.push(path);
          }, 'app.vue');
        } else if (counter > 6000) {
          clearInterval(interval);
          _this2.isAccountReady = true;
          throw new Error('unable to resolve route in time');
        }
      }
    }, 10);
  }
});

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83a8c04e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(220);
function injectStyle (ssrContext) {
  __webpack_require__(210)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83a8c04e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 210:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProfileDropdown__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Aside_AsideToggler__ = __webpack_require__(110);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ProfilePopover: __WEBPACK_IMPORTED_MODULE_0__ProfileDropdown__["a" /* default */],
    AsideToggler: __WEBPACK_IMPORTED_MODULE_1__Aside_AsideToggler__["a" /* default */]
  },
  computed: {
    heading: function heading() {
      return this.$route.path.split('/')[1];
    }
  }
});

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileDropdown_vue__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad4a95fe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileDropdown_vue__ = __webpack_require__(216);
function injectStyle (ssrContext) {
  __webpack_require__(213)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad4a95fe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 213:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_avatar__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_avatar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Avatar: __WEBPACK_IMPORTED_MODULE_0_vue_avatar___default.a
  },
  data: function data() {
    return {};
  },

  methods: {
    logout: function logout() {
      this.$store.dispatch('account/logout');
    },
    openProfile: function openProfile() {
      this.$router.push('/profile');
    },
    command: function command(event) {
      var fn = this[event];
      if (typeof fn === 'function') {
        fn();
      }
    }
  },
  computed: {
    account: function account() {
      return this.$store.state.account;
    }
  }
});

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.account.isAuthenticated)?_c('el-dropdown',{attrs:{"trigger":"click"},on:{"command":_vm.command}},[_c('el-button',{staticClass:"profile__button",attrs:{"type":"text"}},[_c('div',{staticClass:"profile__button__body"},[_c('Avatar',{attrs:{"username":_vm.account.blob.first_name + ' ' + _vm.account.blob.last_name,"src":_vm.account.blob.profile_image_url,"size":40}})],1)]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"profile__dropdown__name",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',[_c('span',{staticClass:"profile__dropdown__name__body"},[_vm._v(_vm._s(_vm.account.blob.first_name))])]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"openProfile","divided":""}},[_vm._v("Profile")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"logout"}},[_vm._v("Log out")])],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    isCollapsed: function isCollapsed() {
      return this.$store.state.layout.navCollapsed;
    },
    sidebarAction: function sidebarAction() {
      return this.isCollapsed ? 'expand' : 'collapse';
    },
    sidebarIndicatorStyle: function sidebarIndicatorStyle() {
      var degree = this.isCollapsed ? 90 : 0;
      return {
        transform: 'rotate(' + degree + 'deg)'
      };
    }
  },
  methods: {
    toggleNav: function toggleNav() {
      this.$store.commit('layout/update', {
        navCollapsed: !this.isCollapsed
      });
    }
  }
});

/***/ }),

/***/ 219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aside__toggler",class:_vm.sidebarAction,on:{"click":_vm.toggleNav}},[_c('div',{staticClass:"aside__toggler__body"},[_vm._t("default",[_c('span')])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('el-row',{staticClass:"bg-row",attrs:{"align":"middle","type":"flex","justify":"space-between"}},[_c('el-col',{staticClass:"lefter"},[_c('AsideToggler',{staticClass:"nav__toggler"}),_vm._v(" "),_c('div',{staticClass:"nav__header"},[_c('h1',[_vm._v("\n          "+_vm._s(_vm.heading)+"\n        ")])])],1),_vm._v(" "),_c('el-col',{staticStyle:{"flex-shrink":"2","text-align":"right"}},[_c('ProfilePopover')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59f9ac69_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(230);
function injectStyle (ssrContext) {
  __webpack_require__(222)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59f9ac69_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 222:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_data_viddsee_submissionStatus__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_eventBus__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AsideToggler__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utilities_SupportButton__ = __webpack_require__(197);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var groupItems = function groupItems(item1, item2, title, key) {
  if (item1 && item1.total || item2 && item2.total) {
    return {
      title: title,
      key: key,
      total: function () {
        var sum = 0;
        if (item1) sum += item1.total;
        if (item2) sum += item2.total;
        return sum;
      }()
    };
  } else {
    return null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    SupportButton: __WEBPACK_IMPORTED_MODULE_4__Utilities_SupportButton__["a" /* default */],
    AsideToggler: __WEBPACK_IMPORTED_MODULE_3__AsideToggler__["a" /* default */]
  },
  computed: {
    isCollapsed: function isCollapsed() {
      return this.$store.state.layout.navCollapsed;
    },
    collapseClass: function collapseClass() {
      return this.isCollapsed ? 'collapsed' : '';
    },
    sidebarAction: function sidebarAction() {
      return this.isCollapsed ? 'Expand' : 'Collapse';
    },
    sidebarIndicatorStyle: function sidebarIndicatorStyle() {
      var degree = this.isCollapsed ? 90 : 0;
      return {
        transform: 'rotate(' + degree + 'deg)'
      };
    },
    shouldShowDetailedDashboard: function shouldShowDetailedDashboard() {
      return this.$route.fullPath === '/dashboard';
    },
    detailedDashboardArray: function detailedDashboardArray() {
      var videos = this.$store.getters['submission/list'];
      var results = {};
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(videos).forEach(function (typeIndex) {
        var info = __WEBPACK_IMPORTED_MODULE_1__assets_data_viddsee_submissionStatus__["a" /* default */].INFO[typeIndex];
        results[typeIndex] = {
          title: info.label,
          key: typeIndex,
          total: videos[typeIndex].length
        };
      });

      // Reorganise how items are being listed here
      return [results[0] ? {
        title: 'Need more info',
        key: 0,
        total: results[0].length
      } : null,
      // 2 and 3 will be combined together (under review & fasttrack)
      results[1], groupItems(results[2], results[3], __WEBPACK_IMPORTED_MODULE_1__assets_data_viddsee_submissionStatus__["a" /* default */].INFO[3].label, 3), groupItems(results[4], results[5], 'Reviewed', 4)];
    }
  },
  methods: {
    toggleNav: function toggleNav() {
      this.$store.commit('layout/update', {
        navCollapsed: !this.isCollapsed
      });
    },
    submenuClicked: function submenuClicked(key) {
      __WEBPACK_IMPORTED_MODULE_2__libs_eventBus__["a" /* default */].$emit('dashboard/scrollToGroup', key);
    },
    closeNavigationMenuIfMobile: function closeNavigationMenuIfMobile() {
      if (window.outerWidth < 480) {
        this.$store.commit('layout/update', {
          navCollapsed: true
        });
      }
    }
  }
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

// import { intercom } from '@/services';

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    openSupport: function openSupport(event) {
      // Uncomment the following line to re-enable Intercom integration.
      // intercom.openIntercom.call(this, event);
      this.$store.commit('dialogue/open', 'support');
    }
  }
});

/***/ }),

/***/ 229:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":_vm.openSupport}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aside"},[_c('el-row',{attrs:{"justify":"space-between","type":"flex"}},[_c('el-col',{staticClass:"brand-logo"},[_c('img',{attrs:{"src":__webpack_require__(231)}})]),_vm._v(" "),_c('el-col',{staticClass:"mobile-toggler"},[_c('AsideToggler')],1)],1),_vm._v(" "),_c('el-menu',{attrs:{"default-active":"0","defaultOpeneds":[
      '/dashboard' ],"router":""},on:{"select":_vm.closeNavigationMenuIfMobile}},[(!_vm.shouldShowDetailedDashboard)?_c('el-menu-item',{attrs:{"index":"/dashboard"}},[_c('i',{staticClass:"el-icon-menu"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Dashboard")])]):_c('el-submenu',{ref:"submenu",attrs:{"index":"/dashboard"}},[_c('template',{attrs:{"slot":"title"},slot:"title"},[_c('i',{staticClass:"el-icon-menu"}),_c('span',[_vm._v("Dashboard")])]),_vm._v(" "),_vm._l((_vm.detailedDashboardArray),function(item,index){return (item)?_c('el-menu-item',{key:index.key,attrs:{"index":''},on:{"click":function($event){_vm.submenuClicked(item.key)}}},[_vm._v("\n        "+_vm._s(item.title)+" "),_c('small',[_vm._v(_vm._s(item.total))])]):_vm._e()})],2),_vm._v(" "),_c('SupportButton',[_c('el-menu-item',{attrs:{"index":""}},[_c('i',{staticClass:"el-icon-question"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Support")])])],1),_vm._v(" "),_c('a',{attrs:{"href":"/#/faq/licensing","target":"_blank","rel":"noopener"}},[_c('el-menu-item',{attrs:{"index":""}},[_c('i',{staticClass:"el-icon-tickets"}),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Licensing FAQ")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"aside__footer"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SupportNew_vue__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_488d6f11_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SupportNew_vue__ = __webpack_require__(234);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SupportNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_488d6f11_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SupportNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      supportEmail: 'storytellers.global@viddsee.com'
    };
  },

  computed: {
    account: function account() {
      var account = this.$store.state.account || {};
      return account.blob || {};
    },
    dialogFormVisible: function dialogFormVisible() {
      return this.$store.state.dialogue.support;
    }
  },
  methods: {
    open: function open() {},
    close: function close() {
      this.$store.commit('dialogue/close', 'support');
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.dialogFormVisible,"append-to-body":true},on:{"open":_vm.open,"close":_vm.close}},[_c('h3',{attrs:{"slot":"title"},slot:"title"},[_c('i',{staticClass:"el-icon-message"}),_vm._v("\n    Support\n  ")]),_vm._v(" "),_c('p',[_vm._v("Hi there! We're here to help you.")]),_vm._v(" "),_c('p',[_vm._v("\n    If you have any questions or need assistance, please feel free to\n    reach out to us at\n    "),_c('a',{attrs:{"href":'mailto:' + _vm.supportEmail}},[_vm._v(_vm._s(_vm.supportEmail))]),_vm._v(". \n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    For quicker response, please provide as much detail as possible including the video title, your name, and any relevant data to your request.\n  ")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":_vm.close}},[_vm._v("Cancel")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_webcall__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_variables__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_urlParser__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_accountBlobNormaliser__ = __webpack_require__(302);






var ACCESS_TOKEN_KEY = 'access_token';

var methods = {
  retrieveUserInfomation: function retrieveUserInfomation() {
    var accessToken = null;

    // Retrieve accessToken from url
    var queries = __WEBPACK_IMPORTED_MODULE_3__utils_urlParser__["a" /* default */].query.parse();
    if (queries.access_token) {
      accessToken = queries.access_token;
      localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
      delete queries.access_token;
      __WEBPACK_IMPORTED_MODULE_3__utils_urlParser__["a" /* default */].query.set(queries);

      // Retrieve accessToken from localStorage
    } else if (localStorage.getItem(ACCESS_TOKEN_KEY)) {
      accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
    }

    return accessToken;
  },
  validateAccessToken: function validateAccessToken(accessToken) {
    return __WEBPACK_IMPORTED_MODULE_1__libs_webcall__["a" /* default */].user.validate(accessToken);
  },
  removeUserInformation: function removeUserInformation() {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
  }
};

var account = {
  namespaced: true,
  state: {
    isAuthenticated: null,
    accessToken: null,
    blob: null,
    // Verification
    shouldAskForVerification: null,
    shouldAskForAddingEmail: null,
    shouldAskForSignup: null,
    shouldAskForAgreement: null,
    needSignup: null
  },
  getters: {},
  mutations: {
    updateUserInformation: function updateUserInformation(state) {
      var userInformationBlob = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var isAuthenticated = !!userInformationBlob.access_token;

      // Update state;
      state.accessToken = userInformationBlob.access_token || null;
      state.blob = isAuthenticated ? __WEBPACK_IMPORTED_MODULE_4__utils_accountBlobNormaliser__["a" /* default */].cleanUpResponse(userInformationBlob) : {};
      // Sign up requirement's state
      state.shouldAskForVerification = !!state.blob.unverified_email;
      state.shouldAskForAddingEmail = !state.blob.primary_email && !state.shouldAskForVerification;
      state.shouldAskForSignup = !(state.blob.film_maker_details && state.blob.film_maker_details.name);
      state.shouldAskForAgreement = state.blob.film_license_agreement === 'not_signed' || state.blob.film_license_agreement === 'not_latest';
      // Summary
      state.needSignup = state.shouldAskForVerification || state.shouldAskForAddingEmail || state.shouldAskForSignup || state.shouldAskForAgreement;
      state.isAuthenticated = isAuthenticated;
    }
  },
  actions: {
    initialiseAccount: function initialiseAccount(_ref) {
      var _this = this;

      var state = _ref.state,
          commit = _ref.commit,
          rootState = _ref.rootState;

      var accessToken = methods.retrieveUserInfomation();
      if (!accessToken) {
        this.dispatch('account/logout', { clearOnly: true });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return methods.validateAccessToken(accessToken).then(function (data) {
        commit('updateUserInformation', data.data);
        __WEBPACK_IMPORTED_MODULE_1__libs_webcall__["a" /* default */].updateAccessToken(accessToken);
      }).catch(function (error) {
        if (error.status === 401) {
          // Kick user only when request is unauthorized
          _this.dispatch('account/logout', { clearOnly: true });
        }
        throw error;
      });
    },
    logout: function logout(_ref2) {
      var state = _ref2.state,
          commit = _ref2.commit,
          rootState = _ref2.rootState;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (options.clearOnly) {
        commit('updateUserInformation');
        methods.removeUserInformation();
        return; // clear only. do not continue.
      }

      var logoutFrame = document.createElement('iframe');
      var logoutCallbackFnName = 'logoutCallbackFn';
      window[logoutCallbackFnName] = function () {
        commit('updateUserInformation');
        methods.removeUserInformation();
        document.body.removeChild(logoutFrame);
      };
      logoutFrame.setAttribute('style', 'display: none;');

      logoutFrame.src = __WEBPACK_IMPORTED_MODULE_2__config_variables__["a" /* default */].BASE_URL + '/logout?origin=false&callback=' + logoutCallbackFnName;
      document.body.appendChild(logoutFrame);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (account);

/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_variables__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResponseError__ = __webpack_require__(282);




var EXPORT_METHODS = ['get', 'head', 'post', 'delete', 'put'];
var TIMEOUT = 120000;
var makeHeader = function makeHeader(accessToken) {
  if (!accessToken) {
    accessToken = localStorage.getItem('access_token');
  }
  return {
    'Authorization': 'Token token="' + accessToken + '"',
    'Accept-Language': 'en'
  };
};

// Default Axios instance for handling HTTP request
var instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: __WEBPACK_IMPORTED_MODULE_1__config_variables__["a" /* default */].API_URL,
  timeout: TIMEOUT,
  headers: makeHeader()
});

// Core API export object
var httpMethods = {
  updateAccessToken: function updateAccessToken(accessToken) {
    instance.defaults.headers = makeHeader(accessToken);
  },

  getHeader: makeHeader
};
// Add a error resolver to the existing axios function
var resolveError = function resolveError(error) {
  if (!navigator.onLine) {
    throw new Error('Application has no access to the internet.', {
      status: 'NO_INTERNET'
    });
  }

  if (error.response) throw new __WEBPACK_IMPORTED_MODULE_2__ResponseError__["a" /* default */](error);
  throw error;
};
EXPORT_METHODS.forEach(function (method) {
  httpMethods[method] = function () {
    return instance[method].apply(instance, arguments).catch(resolveError);
  };
});

/* harmony default export */ __webpack_exports__["a"] = (httpMethods);

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);






var ResponseError = function (_Error) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ResponseError, _Error);

  function ResponseError(responseError) {
    var _ref;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ResponseError);

    for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ResponseError.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ResponseError)).call.apply(_ref, [this].concat(params)));

    _this.message = responseError.toString();
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(responseError.response).forEach(function (key) {
      _this[key] = responseError.response[key];
    });
    return _this;
  }

  return ResponseError;
}(Error);

/* harmony default export */ __webpack_exports__["a"] = (ResponseError);

/***/ }),

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_variables__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core__ = __webpack_require__(262);







/* harmony default export */ __webpack_exports__["a"] = ({
  user: {
    get: function get() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].get.apply(__WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */], ['me'].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(args)));
    },
    validate: function validate(accessToken) {
      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].get('me', {
        headers: {
          'Authorization': 'Token token="' + accessToken + '"',
          'Accept-Language': 'en'
        }
      });
    },
    sendVerificationEmail: function sendVerificationEmail() {
      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].post('send_email_verification');
    },

    /**
     * Add or update an email address to the user account using the provided email address
     * if newEmail is falsey, a noChange key will be inserted to the payload. During noChange,
     * the existing email will be used and a verification email will be sent to the existing
     * email `primary_email`
     * @param {string} newEmail
     */
    updateEmail: function updateEmail() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var payload = {};
      if (!data.email) payload.noChange = true;else payload.email = data.email;

      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].post('user_email_update', payload);
    },

    filmmaker: {
      create: function create(data) {
        return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].post('film_maker_details', data);
      }
    }
  },
  dashboard: {
    list: function list() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].get.apply(__WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */], ['submitvideos'].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(args)));
    }
  },
  submission: {
    new: function _new() {
      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].post('submitvideo', {
        rights_general: true,
        rights_advertising: true,
        rights_media: 'MEDIA_ALL'
      });
    },
    fastTrack: function fastTrack(data) {
      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].post('submitvideos/fast_track', data);
    },
    bulkFastTrack: function bulkFastTrack(data) {
      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].post('submitvideos/bulk', data);
    },
    get: function get(videoId) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([this.getSimple(videoId), this.getExtra(videoId)]).then(function (responses) {
        return {
          data: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, responses[0].data, responses[1].data)
        };
      });
    },
    getSimple: function getSimple(videoId) {
      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].get('submitvideo/' + videoId);
    },
    getExtra: function getExtra(videoId) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([this.collaborators.list(videoId), this.attachments.list(videoId), this.image.list(videoId)]).then(function (responses) {
        var data = responses.map(function (response) {
          return response.data;
        });

        return {
          data: {
            collaborators: data[0].collaborators,
            attachments: data[1],
            image: data[2]
          }
        };
      });
    },

    /**
     * Handle of updates of data by a submission
     * @param {string} videoId
     * @param {object} data to be uploaded
     */
    update: function update(videoId, data) {
      var _this = this;

      if (data.id && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).length === 1) {
        // Nothing to update, just return the latest data.
        return this.get(videoId);
      } else {
        return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].put('submitvideo/' + videoId, data).then(function () {
          return _this.get(videoId);
        });
      }
    },
    getUploadPolicy: function getUploadPolicy(videoId) {
      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].get('submitvideo/' + videoId + '/upload_policy');
    },
    delete: function _delete(videoId) {
      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].get('submitvideo/' + videoId + '/clear_uploads').then(function () {
        return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].delete('submitvideo/' + videoId);
      });
    },

    collaborators: {
      list: function list(videoId) {
        return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].get('submitvideo/' + videoId + '/collaborators');
      },
      add: function add(videoId, data) {
        return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].post('submitvideo/' + videoId + '/collaborators', data);
      },
      get: function get(videoId, collaboratorId) {
        return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].put('submitvideo/' + videoId + '/collaborators');
      },
      update: function update(videoId, collaboratorId, data) {
        return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].put('submitvideo/' + videoId + '/collaborators/' + collaboratorId, data);
      },
      delete: function _delete(videoId, collaboratorId) {
        return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].delete('submitvideo/' + videoId + '/collaborators/' + collaboratorId);
      }
    },
    image: {
      list: function list(videoId) {
        return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].get('submitvideo/' + videoId + '/images').then(function (response) {
          response.data = response.data.map(function (item) {
            var url = item.image.image_file_url || '';
            var name = url.split('/').splice(-1, 1)[0];
            delete item.image;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, {
              url: url,
              name: name
            });
          });

          return response;
        });
      },
      delete: function _delete(videoId, fileId) {
        return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].delete('submitvideo/' + videoId + '/image/' + fileId);
      }
    },
    attachments: {
      list: function list(videoId) {
        return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].get('submitvideo/' + videoId + '/attachments');
      },
      add: function add(videoId, data) {
        return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].post('submitvideo/' + videoId + '/attachments', data);
      },
      update: function update(videoId, fileId, data) {
        return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].put('submitvideo/' + videoId + '/attachments/' + fileId, data);
      },
      delete: function _delete(videoId, fileId) {
        return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].delete('submitvideo/' + videoId + '/attachments/' + fileId);
      }
    },
    additionalAgreements: function additionalAgreements(videoId) {
      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].get('submitvideo/' + videoId + '/additional_agreements');
    },
    fastTrackAdditionalAgreements: function fastTrackAdditionalAgreements() {
      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].get('/additional_agreements');
    }
  },
  support: {
    send: function send(data) {
      var userName = data.name;

      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].post('support', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
        subject: 'Creator: ' + userName + ' requested for suppport'
      }, data));
    },
    log: function log(data) {
      if (false) {
        /* eslint no-console: 0 */
        console.log(data); // don't send tracker during development
        return _Promise.resolve();
      }

      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].post('https://tracker.viddsee.com/log', data, {
        headers: ''
      });
    }
  },
  agreement: {
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].get('film_license_agreement/latest');
    },
    sign: function sign(data) {
      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].post('film_license/sign', data);
    },
    getUpgradableLicense: function getUpgradableLicense(data) {
      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].get('submitvideos/license_upgradable', data);
    }
  },

  app: {
    getLocaleInformation: function getLocaleInformation() {
      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_4__config_variables__["a" /* default */].BASE_URL + '/ip_json');
    }
  },

  survey: {
    postSurvey: function postSurvey(surveyId, answers) {
      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].post('' + __WEBPACK_IMPORTED_MODULE_4__config_variables__["a" /* default */].Survey.ENDPOINT, {
        survey_id: surveyId,
        survey_answers: answers
      });
    }
  },

  juree: {
    info: function info(config) {
      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].get('../v2/juree/info', config);
    },
    country: function country(_ref, config) {
      var countryName = _ref.countryName;

      return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].get('../v2/juree/country/' + countryName, config);
    }
  },

  // Webcall's own API
  updateAccessToken: function updateAccessToken(accessToken) {
    __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].updateAccessToken(accessToken);
  },
  getHeader: function getHeader() {
    return __WEBPACK_IMPORTED_MODULE_5__core__["a" /* default */].getHeader();
  }
});

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var ERROR = {
  NO_HISTORY_API: 'This browser does not support the History API'
};

var query = {
  get: function get() {
    var getOriginal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return window.location.search.substring(getOriginal ? 0 : 1);
  },
  parse: function parse() {
    var result = {};
    query.get().split('&').forEach(function (queryStr) {
      if (queryStr) {
        var duo = queryStr.split('=');
        result[duo[0]] = duo[1];
      }
    });
    return result;
  },
  encode: function encode(queries) {
    return '?' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(queries).map(function (key) {
      return key + '=' + queries[key];
    }).join('&');
  },


  /**
   * Append or replace new query string to the url.
   * @param {object} newQueries - a key-value paired object
   */
  add: function add(newQueries) {
    if (!window.history) throw new Error(ERROR.NO_HISTORY_API);

    var existingQueries = query.parse();
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newQueries).forEach(function (key) {
      existingQueries[key] = newQueries[key];
    });
    var newPathName = path.build(null, query.encode(existingQueries));
    history.replaceState({}, null, newPathName);
  },


  /**
   * Replace query string with the provided value
   * @param {object} newQueries - a key-value paired object
   */
  set: function set(newQueries) {
    if (!window.history) throw new Error(ERROR.NO_HISTORY_API);

    var newPathName = path.build(null, query.encode(newQueries));
    history.replaceState({}, null, newPathName);
  },


  /**
   * Remove a query and its value
   * @param {string} keyToDelete - name of the key
   */
  remove: function remove(keyToDelete) {
    if (!window.history) throw new Error(ERROR.NO_HISTORY_API);

    var existingQueries = query.parse();
    delete existingQueries[keyToDelete];
    var newPathName = path.build(null, query.encode(existingQueries));
    history.replaceState({}, null, newPathName);
  }
};

var path = {
  get: function get() {
    var getOriginal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return window.location.pathname.substring(getOriginal ? 0 : 1);
  },
  build: function build(newPath, newQuery, newHash) {
    newPath = newPath || path.get();
    newQuery = newQuery || query.get(true);
    newHash = newHash || window.location.hash;

    return '/' + newPath + newQuery + newHash;
  },
  update: function update(newPath) {
    if (window.history) {
      var newPathName = path.build(newPath);
      history.replaceState({}, null, newPathName);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  query: query,
  path: path
});

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * This function is copied and modified from viddsee_api's vs-profile.js
   * https://github.com/viddsee/viddsee_api/blob/0b508b14f8e376cca13e6ac890f31bce9226676c/assets/javascripts/vs-profile.js#L12
   *
   * Due to server side response inconsistency between unverification behaviour.
   * From the client side, I will need to clean up response first to keep the front end logic less complicated
   * @param {*} original
   */
  cleanUpResponse: function cleanUpResponse(original) {
    var result = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, original);
    if (result.is_email_verified === false) {
      // Case: User has both primary_email and unverified email.
      //       In this case, unverified_email take precedence,
      //       the existing primary email should be ignored and removed.
      if (result.unverified_email && result.primary_email) {
        result.primary_email = '';

        // Case: User has an unverified primary email.
        //       To keep the behaviour consistent, we will move primary_email to unverified_email
        //       The primary_email field should be ignored and removed.
      } else {
        result.unverified_email = result.primary_email;
        result.primary_email = '';
      }
      // Case: At this moment, unverified_email field is not cleared after verification.
      //       See: https://github.com/viddsee/viddsee_api/issues/115
    } else if (result.unverified_email === result.primary_email) {
      delete result.unverified_email;

      // Case: A unverified_email exist and it is not the same with primary_email.
      //       This imply that user email is not verified
    } else if (result.unverified_email) {}
    // Do nothing

    // At the end, remove this is_email_verified
    delete result.is_email_verified;
    // Also remove the deprecated field
    delete result.unconfirmed_email;

    return result;
  }
});

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_webcall__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_camelCase__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_camelCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__legacySpecification__ = __webpack_require__(322);










// Instruction maker
var makeInstruction = function makeInstruction(path, data) {
  return {
    path: path,
    data: data
  };
};

var extractItem = function extractItem(itemNode) {
  var itemType = itemNode.dataset.itemType || itemNode.className;
  var itemComponent = itemType === 'component' ? {
    componentName: itemNode.dataset.componentName
  } : null;

  var itemAction = itemType === 'action' ? {
    inputName: itemNode.dataset.inputName,
    inputType: itemNode.dataset.inputType,
    inputValue: itemNode.dataset.inputValue,
    inputValuePrefilled: itemNode.dataset.inputValuePrefilled,
    inputValueDeselect: itemNode.dataset.inputValueDeselect
  } : null;

  return {
    itemType: itemType,
    itemAction: itemAction,
    itemComponent: itemComponent,
    itemHTML: itemNode.innerHTML
  };
};

var extractItems = function extractItems(htmlNode) {
  var title = (htmlNode.querySelector('.title') || {}).textContent;
  var itemNodes = htmlNode.querySelectorAll('.content, .action, .component');

  // Prepare result
  return {
    title: title,
    itemFormName: htmlNode.dataset.formName,
    optional: !!htmlNode.dataset.optional,
    items: [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(itemNodes)).reduce(function (acc, itemNode) {
      acc.push(extractItem(itemNode));
      return acc;
    }, [])
  };
};

// Result array of object containing path and data
var processor = {
  specification: function specification(data) {
    try {
      var rawSpecification = JSON.parse(data.innerHTML);
      var specification = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rawSpecification).reduce(function (acc, agreementName) {
        var specificationItem = rawSpecification[agreementName];
        acc[agreementName] = {
          title: specificationItem.title,
          sequence: specificationItem.sequence.map(__WEBPACK_IMPORTED_MODULE_6_lodash_camelCase___default.a)
        };
        return acc;
      }, {});

      return [makeInstruction('specification', specification)];
    } catch (error) {
      return [makeInstruction('specification', null)];
    }
  },
  license: function license(data) {
    return data.map(function (htmlNode) {
      var licenseName = __WEBPACK_IMPORTED_MODULE_6_lodash_camelCase___default()(htmlNode.dataset.license);
      return makeInstruction('license.' + licenseName, extractItems(htmlNode));
    });
  },
  action: function action(data) {
    return data.map(function (htmlNode) {
      var actionName = __WEBPACK_IMPORTED_MODULE_6_lodash_camelCase___default()(htmlNode.dataset.action);
      return makeInstruction('action.' + actionName, extractItems(htmlNode));
    });
  }
};

var agreement = {
  namespaced: true,
  state: {
    hasError: false,
    specification: null,
    license: {},
    action: {}
  },
  mutations: {
    update: function update(state, _ref) {
      var path = _ref.path,
          data = _ref.data;

      var subPath = path.split('.');

      if (subPath.length === 1) {
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state, path, data);
      } else {
        __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state[subPath[0]], subPath[1], data);
      }
    },
    declareError: function declareError(state) {
      state.hasError = true;
    }
  },
  actions: {
    initialise: function initialise(_ref2) {
      var state = _ref2.state,
          commit = _ref2.commit,
          rootState = _ref2.rootState;

      __WEBPACK_IMPORTED_MODULE_5__libs_webcall__["a" /* default */].agreement.get()
      // Obtain data remotely
      .then(function (_ref3) {
        var data = _ref3.data;

        var agreementHTMLString = data.terms;
        return agreementHTMLString;
      })
      // Filter data according to source
      .then(function (htmlString) {
        var parser = new DOMParser();
        var agreementDoc = parser.parseFromString(htmlString, 'text/html');
        var nodes = {
          license: [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(agreementDoc.querySelectorAll('[data-license]'))),
          action: [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(agreementDoc.querySelectorAll('[data-action]'))),
          specification: agreementDoc.querySelector('[data-specification]')
        };

        return nodes;
      })
      // Process each source
      .then(function (nodes) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(nodes).map(function (_ref4) {
          var _ref5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref4, 2),
              key = _ref5[0],
              value = _ref5[1];

          return processor[key](value);
        });
      }).then(function (results) {
        var specificationData = results[2][0].data;
        if (!specificationData) {
          return __WEBPACK_IMPORTED_MODULE_7__legacySpecification__["a" /* default */].makeCompatible(results);
        }
        return results;
      })
      // Commit results
      .then(function (results) {
        results.forEach(function (result) {
          result.forEach(function (instruction) {
            commit('update', instruction);
          });
        });
      }).catch(function (error) {
        commit('declareError');
        throw error;
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (agreement);

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);


var legacy = {
  specification: {
    'film-license': {
      title: 'Viddsee Film License Agreement',
      sequence: ['whatIsViddsee', 'termsAndConditions', 'nonExclusive', 'filmmakerDetailsForm', 'filmmakerFilmForm', 'thirdParty', 'monetisation', 'agreement']
    },
    'lite': {
      title: 'Viddsee Film License Agreement',
      sequence: ['termsAndConditions']
    },
    'intro': {
      title: 'Viddsee Film License Agreement',
      sequence: ['termsAndConditions', 'agreement']
    },
    'submission': {
      title: '',
      sequence: ['thirdParty', 'monetisation']
    }
  },
  action: {
    filmmakerFilmForm: {
      id: 'filmmakerFilmForm',
      itemFormName: 'films',
      optional: false,
      items: [{
        itemType: 'component',
        itemAction: null,
        itemComponent: {
          componentName: 'app-your-film'
        },
        itemHTML: ''
      }]
    },
    filmmakerDetailsForm: {
      id: 'filmmakerDetailsForm',
      itemFormName: 'filmmakerDetails',
      optional: false,
      items: [{
        itemType: 'component',
        itemAction: null,
        itemComponent: {
          componentName: 'app-your-details'
        },
        itemHTML: ''
      }]
    }
  },
  itemFormName: {
    agreement: 'terms-and-conditions',
    monetisation: 'rights_advertising',
    thirdParty: 'rights_general'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  makeCompatible: function makeCompatible(results) {
    results.forEach(function (result) {
      result.forEach(function (item) {
        if (item.path === 'specification') {
          item.data = legacy.specification;
        }

        if (item.path.split('.')[0] === 'action') {
          var actionName = item.path.split('.')[1];

          if (legacy.itemFormName[actionName]) {
            item.data.itemFormName = legacy.itemFormName[actionName];
          }
        }
      });

      if (result[0].path.split('.')[0] === 'action') {
        result.push.apply(result, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(legacy.action).map(function (actionName) {
          return {
            path: 'action.' + actionName,
            data: legacy.action[actionName]
          };
        })));
      }
    });
    return results;
  }
});

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_string__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_webcall__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_data_viddsee_submissionStatus__ = __webpack_require__(99);








var unescapeData = function unescapeData(jsonObject) {
  var processedData = {};
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(jsonObject).forEach(function (key) {
    var value = jsonObject[key];
    if (typeof value === 'string') {
      processedData[key] = __WEBPACK_IMPORTED_MODULE_4_lodash_string___default.a.unescape(jsonObject[key]);
    } else {
      processedData[key] = jsonObject[key];
    }
  });
  return processedData;
};

var addPreSubmissionTreatment = function addPreSubmissionTreatment(submission) {
  return {
    // A non-string value will cause render issue on vs-admin side.
    // TODO: Remove this after if vs-admin resolve this issue.
    festivals: submission.festivals || ''
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {},
  getters: {
    list: function list(state) {
      var submissions = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(state).map(function (submissionId) {
        return state[submissionId];
      });
      var result = [];
      submissions.forEach(function (submission) {
        var index = __WEBPACK_IMPORTED_MODULE_6__assets_data_viddsee_submissionStatus__["a" /* default */].TYPE[submission.status];
        if (!result[index]) result[index] = [];
        result[index].push(submission);
      });
      // Sort the data first by updated time
      return result.map(function (videos) {
        return videos.sort(function (a, b) {
          return a.updated_at > b.updated_at ? -1 : 1;
        });
      });
    }
  },
  // Local Mutation - to be performed after remote
  mutations: {
    add: function add(state, data) {
      var processedData = unescapeData(data);
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state, data.id, processedData);
    },
    update: function update(state, data) {
      var processedData = unescapeData(data);
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(state, data.id, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state[data.id], processedData) // Update by override existing fields
      );
    },
    remove: function remove(state, data) {
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].delete(state, data.id);
    }
  },
  // Remote + Local Mutation
  actions: {
    create: function create(_ref) {
      var state = _ref.state,
          commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_5__libs_webcall__["a" /* default */].submission.new().then(function (_ref2) {
        var data = _ref2.data;

        commit('add', data);
        return data;
      });
    },
    list: function list(_ref3) {
      var state = _ref3.state,
          commit = _ref3.commit,
          getters = _ref3.getters;

      return __WEBPACK_IMPORTED_MODULE_5__libs_webcall__["a" /* default */].dashboard.list({
        params: {
          per_page: 999,
          current_page: 0
        }
      }).then(function (_ref4) {
        var data = _ref4.data;

        data.videos.forEach(function (video) {
          return commit('add', video);
        });
        return getters.list;
      });
    },
    get: function get(_ref5, submissionId) {
      var state = _ref5.state,
          commit = _ref5.commit,
          getters = _ref5.getters;

      return __WEBPACK_IMPORTED_MODULE_5__libs_webcall__["a" /* default */].submission.get(submissionId).then(function (_ref6) {
        var data = _ref6.data;

        commit('add', data);
        return data;
      });
    },
    remove: function remove(_ref7, submission) {
      var state = _ref7.state,
          commit = _ref7.commit;

      return __WEBPACK_IMPORTED_MODULE_5__libs_webcall__["a" /* default */].submission.delete(submission.id).then(function () {
        return commit('remove', submission);
      });
    },
    update: function update(_ref8, submission) {
      var state = _ref8.state,
          commit = _ref8.commit,
          getters = _ref8.getters;

      // TODO: Implement error notification / fallback
      //       Make sure a failed update does not erase user's local change
      return __WEBPACK_IMPORTED_MODULE_5__libs_webcall__["a" /* default */].submission.update(submission.id, submission).then(function (_ref9) {
        var data = _ref9.data;
        return commit('update', data);
      });
    },
    submit: function submit(_ref10, submission) {
      var state = _ref10.state,
          commit = _ref10.commit,
          getters = _ref10.getters;

      var currentStatus = __WEBPACK_IMPORTED_MODULE_6__assets_data_viddsee_submissionStatus__["a" /* default */].TYPE[submission.status];
      if (currentStatus <= __WEBPACK_IMPORTED_MODULE_6__assets_data_viddsee_submissionStatus__["a" /* default */].TYPE.incomplete) {
        return __WEBPACK_IMPORTED_MODULE_5__libs_webcall__["a" /* default */].submission.update(submission.id, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, addPreSubmissionTreatment(submission), {
          status: 'pending'
        }));
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }
    }
  }
});

/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Submission_rules__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(44);
/**
 * This store manage the progress of a submission.
 * It depends on the submission data and the rules specified for the steps
 */




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {},
  getters: {
    hasError: function hasError(state) {
      return function (id, index) {
        if (!state[id]) return true;

        var stepResults = state[id][index];
        if (!stepResults) return false;

        var completeness = stepResults.some(function (result) {
          return !!result.error;
        });
        return completeness;
      };
    },
    submittable: function submittable(state, getters) {
      return function (id) {
        if (!state[id]) return false;else {
          return !state[id].some(function (stepResults, index) {
            return getters.hasError(id, index);
          });
        }
      };
    }

  },
  mutations: {
    update: function update(state, _ref) {
      var id = _ref.id,
          results = _ref.results;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, id, results);
    }
  },
  actions: {
    update: function update(_ref2, id) {
      var state = _ref2.state,
          commit = _ref2.commit,
          getters = _ref2.getters;

      var submission = __WEBPACK_IMPORTED_MODULE_2____["a" /* default */].state.submission[id];
      var results = __WEBPACK_IMPORTED_MODULE_1__components_Submission_rules__["a" /* default */].managers.map(function (fn, index) {
        return fn(__WEBPACK_IMPORTED_MODULE_1__components_Submission_rules__["a" /* default */].rules[index], submission).filter(function (result) {
          return result != null;
        });
      });
      commit('update', {
        id: id,
        results: results
      });
    }
  }
});

/***/ }),

/***/ 394:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_uploader__ = __webpack_require__(395);
/**
 * This module define
 *
 */



var uploadQueue = {
  namespaced: true,
  state: {
    activeCounter: 0,
    uploader: null
  },
  getters: {},
  mutations: {
    // Main video uploading commits
    addVideo: function addVideo(state, _ref) {
      var fileMeta = _ref.fileMeta,
          updateHandler = _ref.updateHandler;

      var id = fileMeta.id;
      var queue = state[id] || {};
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, id, {
        video: queue.video || {}
      });
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state[id].video, 'instance', state.uploader.upload(fileMeta, updateHandler));
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state[id].video, 'fileMeta', fileMeta);
      state.activeCounter += 1;
    },
    updateVideo: function updateVideo(state, _ref2) {
      var id = _ref2.id,
          progress = _ref2.progress;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state[id].video, 'progress', progress);
    },
    removeVideo: function removeVideo(state, _ref3) {
      var id = _ref3.id;

      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].delete(state[id], 'video');
      state.activeCounter -= 1;
    },
    setupUploader: function setupUploader(state) {
      state.uploader = state.uploader || new __WEBPACK_IMPORTED_MODULE_1__libs_uploader__["a" /* default */]();
    }
  },
  actions: {
    /**
     * Add a video file into the queue. This will also kick off the AWS uploading process.
     * Completed or failed video upload will cause the removal of this video from uploadQueue.
     * An error will be thrown on failure to upload.
     * @param {*} Context of the Vuex store
     * @param {*} fileMeta
     * @returns the url to AWS upon the completion of uploading
     */
    enqueueVideo: function enqueueVideo(_ref4, fileMeta) {
      var state = _ref4.state,
          commit = _ref4.commit,
          getters = _ref4.getters;

      commit('setupUploader');

      // Initialise a blank video item
      commit('addVideo', {
        fileMeta: fileMeta,
        updateHandler: function updateHandler(progress) {
          commit('updateVideo', { id: fileMeta.id, progress: progress });
        }
      });
      return state[fileMeta.id].video.instance.then(function (awsPath) {
        commit('removeVideo', { id: fileMeta.id });
        return awsPath;
      }).catch(function (error) {
        commit('removeVideo', { id: fileMeta.id });
        throw error;
      });
    },

    /**
     * Dequeue video form the upload queue.
     * This will cancel specified on-going upload a submission.
     * @param {*} Context of the Vuex store
     * @param {*} submissionId
     */
    dequeueVideo: function dequeueVideo(_ref5, submissionId) {
      var state = _ref5.state,
          commit = _ref5.commit,
          getters = _ref5.getters;

      var fileMeta = state[submissionId].video.fileMeta;

      state.uploader.cancel(fileMeta);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (uploadQueue);

/***/ }),

/***/ 395:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_evaporate__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_evaporate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_evaporate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_spark_md5__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_spark_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_spark_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_variables__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_webcall__ = __webpack_require__(30);







/**
 * TODO: Need to implement uploader inside a web-worker. Currently slowing down the main thread (i.e. UI) when uploading is in progress.
 * Make the default Evaporate configuration for uploading the main video file.
 * @returns a configuration file for Evaporate.create()
 */
var makeEvaporateConfig = function makeEvaporateConfig() {
  var config = {
    awsSignatureVersion: 2,
    signerUrl: __WEBPACK_IMPORTED_MODULE_4__config_variables__["a" /* default */].AWS.SIGNER_URL,
    signHeaders: __WEBPACK_IMPORTED_MODULE_5__libs_webcall__["a" /* default */].getHeader(),
    aws_key: __WEBPACK_IMPORTED_MODULE_4__config_variables__["a" /* default */].AWS.KEY,
    bucket: __WEBPACK_IMPORTED_MODULE_4__config_variables__["a" /* default */].AWS.BUCKET,

    encodeFilename: false,
    logging: false,
    computeContentMd5: true,
    cryptoMd5Method: function cryptoMd5Method(data) {
      return btoa(__WEBPACK_IMPORTED_MODULE_3_spark_md5___default.a.ArrayBuffer.hash(data, true));
    },
    onlyRetryForSameFileName: true,
    s3Acceleration: false
  };
  // NOTE: If s3Acceleration is disabled execute the 2 lines below.
  if (!config.s3Acceleration) {
    config.aws_url = __WEBPACK_IMPORTED_MODULE_4__config_variables__["a" /* default */].AWS.UPLOAD_ENDPOINT;
    config.cloudfront = true;
  }
  return config;
};

/**
 * Generate aws file key using a fileMeta object.
 * @param {*} fileMeta
 */
var makeAwsFileKey = function makeAwsFileKey(fileMeta) {
  if (!fileMeta.path || !fileMeta.name) throw new Error('fileMeta.path and/or fileMeta.name is invalid');
  return fileMeta.path + fileMeta.name;
};

/**
 * Uploader - abstract the upload process.
 * Uploader currently uses evaporate to handle video uploading.
 */

var Uploader = function () {
  function Uploader() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Uploader);

    this.config = makeEvaporateConfig();
    this.evaporate = __WEBPACK_IMPORTED_MODULE_2_evaporate___default.a.create(this.config);
  }

  /**
   * Upload a file to AWS
   * @param {object} fileMeta
   * @param {function} progressTickCallback
   * @returns the url to AWS upon the completion of uploading
   */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Uploader, [{
    key: 'upload',
    value: function upload(fileMeta, progressTickCallback) {
      // Begin uploading process
      return this.evaporate.then(function (evaporate) {
        return evaporate.add({
          'name': makeAwsFileKey(fileMeta),
          'file': fileMeta.file,
          'x-amz-acl': 'public-read',
          'progress': progressTickCallback
        });
      })
      // awsS3ObjectKey format: bucketName/name
      .then(function (awsS3ObjectKey) {
        var filePathUrl = 'https://viddsee.s3-ap-southeast-1.amazonaws.com/' + awsS3ObjectKey;
        return filePathUrl;
      });
    }

    /**
     * Cancel an on-going AWS upload
     * @param {object} fileMeta
     * @returns a promise that resolves when the upload is completely canceled or rejects if the upload could not be canceled without errors.
     */

  }, {
    key: 'cancel',
    value: function cancel(fileMeta) {
      // Begin uploading process
      var awsS3ObjectKey = __WEBPACK_IMPORTED_MODULE_4__config_variables__["a" /* default */].AWS.BUCKET + '/' + makeAwsFileKey(fileMeta);
      return this.evaporate.then(function (evaporate) {
        return evaporate.cancel([awsS3ObjectKey]);
      });
    }
  }]);

  return Uploader;
}();

/* harmony default export */ __webpack_exports__["a"] = (Uploader);

/***/ }),

/***/ 398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    support: false
  },
  mutations: {
    open: function open(state, target) {
      if (state[target] === undefined) throw new Error("Cannot find state named \"" + target + "\"");
      state[target] = true;
    },
    close: function close(state, target) {
      if (state[target] === undefined) throw new Error("Cannot find state named \"" + target + "\"");
      state[target] = false;
    }
  }
});

/***/ }),

/***/ 399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var layout = {
  namespaced: true,
  state: {
    navCollapsed: window.outerWidth < 920,
    header: true,
    main: true,
    aside: true,
    footer: true
  },
  getters: {},
  mutations: {
    /**
     * Update the layout state
     * @param {*} state
     * @param {Object} payload - with key as layout name and value as its corresponding state
     */
    update: function update(state, payload) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).forEach(function (key) {
        if (state[key] != null) {
          state[key] = payload[key];
        }
      });
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (layout);

/***/ }),

/***/ 402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @return an instance with `unregisterWatcher` which you can use to unregister the event listeners
 */
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var onOffline = _ref.onOffline,
      onOnline = _ref.onOnline;

  window.addEventListener('offline', onOffline);
  window.addEventListener('online', onOnline);

  return {
    unregisterWatcher: function unregisterWatcher() {
      window.addEventListener('offline', onOffline);
      window.addEventListener('online', onOnline);
    }
  };
});

/***/ }),

/***/ 403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CardCol__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Inliner__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Spacer__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TelInput__ = __webpack_require__(413);

/**
 * Register all shared component into vue globally
 */


// Shared Components





var components = {
  'card-col': __WEBPACK_IMPORTED_MODULE_2__CardCol__["a" /* default */],
  'inliner': __WEBPACK_IMPORTED_MODULE_3__Inliner__["a" /* default */],
  'spacer': __WEBPACK_IMPORTED_MODULE_4__Spacer__["a" /* default */],
  'el-tel-input': __WEBPACK_IMPORTED_MODULE_5__TelInput__["a" /* default */]
};

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(components).forEach(function (key) {
  var component = components[key];
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('sh-' + key, component);
});

/***/ }),

/***/ 404:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 405:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 406:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',{staticClass:"card-col"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 407:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ad69a71_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inliner_vue__ = __webpack_require__(409);
function injectStyle (ssrContext) {
  __webpack_require__(408)
}
var normalizeComponent = __webpack_require__(7)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ad69a71_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inliner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 408:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 409:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inliner"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spacer_vue__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a8ab538_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spacer_vue__ = __webpack_require__(412);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Spacer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a8ab538_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spacer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 411:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['by'],
  computed: {
    height: function height() {
      return {
        'margin-top': this.by + 'em'
      };
    }
  }
});

/***/ }),

/***/ 412:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.height)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5387fd2c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(426);
function injectStyle (ssrContext) {
  __webpack_require__(414)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5387fd2c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 414:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_webcall__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_libphonenumber_js__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_phone_input__ = __webpack_require__(418);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    vuePhoneInput: __WEBPACK_IMPORTED_MODULE_2__vue_phone_input__["a" /* default */]
  },
  props: {
    value: {
      default: ''
    },
    disabled: {
      default: false
    }
  },
  computed: {
    parsedNumber: function parsedNumber() {
      var result = {
        country: '',
        phone: ''
      };

      if (this.formatter !== null && this.value) {
        this.formatter.input(this.value);
        result.country = this.formatter.country ? this.formatter.country.toLowerCase() : '';
        result.phone = this.formatter.national_number || '';
      }

      if (!result.country) {
        result.country = this.defaultCountryCode;
      }

      return result;
    }
  },
  data: function data() {
    return {
      defaultCountryCode: '',
      formatter: null
    };
  },

  methods: {
    change: function change(phoneData) {
      if (phoneData.phone) {
        this.$emit('input', phoneData.value);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    /* eslint new-cap: 0 */

    __WEBPACK_IMPORTED_MODULE_0__libs_webcall__["a" /* default */].app.getLocaleInformation().then(function (_ref) {
      var data = _ref.data;

      _this.defaultCountryCode = data.country_code.toLowerCase();
      _this.formatter = new __WEBPACK_IMPORTED_MODULE_1_libphonenumber_js__["a" /* asYouType */](data.country_code);
      _this.$refs.vuePhoneInput.setCode(_this.parsedNumber.country);
      _this.$refs.vuePhoneInput.phoneNumber = _this.parsedNumber.phone;
    });
  }
});

/***/ }),

/***/ 417:
/***/ (function(module, exports) {

module.exports = {"country_phone_code_to_countries":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"800":["001"],"808":["001"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"870":["001"],"878":["001"],"880":["BD"],"881":["001"],"882":["001"],"883":["001"],"886":["TW"],"888":["001"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"979":["001"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","[46]\\d{4}|[01589]\\d{5}"],"AD":["376","[16]\\d{5,8}|[37-9]\\d{5}",[["(\\d{3})(\\d{3})","$1 $2",["[137-9]|6[0-8]"]],["(\\d{4})(\\d{4})","$1 $2",["180","180[02]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["690"]]]],"AE":["971","[2-79]\\d{7,8}|800\\d{2,9}",[["([2-4679])(\\d{3})(\\d{4})","$1 $2 $3",["[2-4679][2-8]"]],["(5\\d)(\\d{3})(\\d{4})","$1 $2 $3",["5"]],["([479]00)(\\d)(\\d{5})","$1 $2 $3",["[479]00"],"$1"],["([68]00)(\\d{2,9})","$1 $2",["[68]00"],"$1"]],"0","0$1"],"AF":["93","[2-7]\\d{8}",[["([2-7]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"]]],"0","0$1"],"AG":["1","[2589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"268"],"AI":["1","[2589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"264"],"AL":["355","[2-57]\\d{7}|6\\d{8}|8\\d{5,7}|9\\d{5}",[["(4)(\\d{3})(\\d{4})","$1 $2 $3",["4[0-6]"]],["(6\\d)(\\d{3})(\\d{4})","$1 $2 $3",["6"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4[7-9]"]],["(\\d{3})(\\d{3,5})","$1 $2",["[235][16-9]|[79]|8[016-9]"]]],"0","0$1"],"AM":["374","[1-9]\\d{7}",[["(\\d{2})(\\d{6})","$1 $2",["1|47"]],["(\\d{2})(\\d{6})","$1 $2",["4[1349]|[5-7]|88|9[1-9]"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23]"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["8|90"],"0 $1"]],"0","(0$1)"],"AO":["244","[29]\\d{8}",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3"]]],"AR":["54","11\\d{8}|[2368]\\d{9}|9\\d{10}",[["([68]\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"]],["(9)(11)(\\d{4})(\\d{4})","$2 15-$3-$4",["911"],null,null,"$1 $2 $3-$4"],["(9)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9(?:2[2-4689]|3[3-8])","9(?:2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578]))","9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))","9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"],null,null,"$1 $2 $3-$4"],["(9)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9[23]"],null,null,"$1 $2 $3-$4"],["(11)(\\d{4})(\\d{4})","$1 $2-$3",["11"],null,"true"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578])","2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))","2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"],null,"true"],["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["[23]"],null,"true"]],"0","0$1","0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))?15)?","9$1"],"AS":["1","[5689]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"684"],"AT":["43","[1-9]\\d{3,12}",[["(116\\d{3})","$1",["116"],"$1"],["(1)(\\d{3,12})","$1 $2",["1"]],["(5\\d)(\\d{3,5})","$1 $2",["5[079]"]],["(5\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["5[079]"]],["(5\\d)(\\d{4})(\\d{4,7})","$1 $2 $3",["5[079]"]],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:[28]0|32)|[89]"]],["(\\d{4})(\\d{3,9})","$1 $2",["2|3(?:1[1-578]|[3-8])|4[2378]|5[2-6]|6(?:[12]|4[1-9]|5[468])|7(?:[24][1-8]|35|[5-79])"]]],"0","0$1"],"AU":["61","1\\d{4,9}|[2-578]\\d{8}",[["([2378])(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|[45]"],"0$1"],["(16)(\\d{3,4})","$1 $2",["16"],"0$1"],["(16)(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(1[389]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1[389]0","1(?:[38]0|9)0"]],["(180)(2\\d{3})","$1 $2",["180","1802"]],["(19\\d)(\\d{3})","$1 $2",["19[13]"]],["(19\\d{2})(\\d{4})","$1 $2",["19[679]"]],["(13)(\\d{2})(\\d{2})","$1 $2 $3",["13[1-9]"]]],"0",null,null,null,null,null,["[237]\\d{8}|8(?:51(?:0(?:0[03-9]|[1247]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-6])|1(?:1[69]|[23]\\d|4[0-4]))|[6-8]\\d{4}|9(?:[02-9]\\d{3}|1(?:[0-57-9]\\d{2}|6[0135-9]\\d)))\\d{3}","14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12457-9]|9[017-9])\\d{6}","180(?:0\\d{3}|2)\\d{3}","19(?:0[0126]\\d|[679])\\d{5}","500\\d{6}",null,null,"16\\d{3,7}","550\\d{6}","13(?:00\\d{3}|45[0-4]|\\d)\\d{3}"]],"AW":["297","[25-9]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"AX":["358","[13]\\d{5,9}|2\\d{4,9}|4\\d{6,10}|5\\d{6,9}|[67]\\d{7,9}|8\\d{7,8}",[["(\\d{3})(\\d{3,7})","$1 $2",["(?:[1-3]0|[6-8])0"]],["(116\\d{3})","$1",["116"],"$1"],["(\\d{2})(\\d{3,9})","$1 $2",["1(?:0[1-9]|[3-9])|2(?:0[1-9]|9)|30[1-9]|4|50|7(?:[13]|5[03-9])"]],["(\\d)(\\d{4})","$1 $2",["9[1-8]"]],["(\\d)(\\d{5,9})","$1 $2",["[235689][1-8]"]],["(39\\d)(\\d{3})(\\d{3})","$1 $2 $3",["39"]]],"0",null,null,null,null,null,["18[1-8]\\d{4,6}","4(?:[0-8]\\d{5,8}|9\\d{9})|50\\d{6,8}","800\\d{5,6}","[67]00\\d{5,6}",null,null,"10(?:0\\d{4,6}|[1-37-9]\\d{5,7}|[46]\\d{3,7}|5\\d{4,7})|2(?:0(?:0\\d{4,6}|[1346-8]\\d{5,7}|2(?:[023]\\d{4,5}|[14-9]\\d{4,6})|5(?:\\d{3}|\\d{5,7})|9(?:[0-7]\\d{4,6}|[89]\\d{1,6}))|9\\d{5,8})|3(?:0(?:0\\d{3,7}|[1-57-9]\\d{5,7}|6(?:\\d{3}|\\d{5,7}))|44\\d{3}|93\\d{5,7})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{5,6})"]],"AZ":["994","[1-9]\\d{8}",[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2(?:[0-36]|[45]2)|365"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[4-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"]],"0","(0$1)"],"BA":["387","[3-9]\\d{7,8}",[["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-356]|[7-9]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6[047]"]]],"0","0$1"],"BB":["1","[2589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"246"],"BD":["880","[2-79]\\d{5,9}|1\\d{9}|8[0-7]\\d{4,8}",[["(2)(\\d{7,8})","$1-$2",["2"]],["(\\d{2})(\\d{4,6})","$1-$2",["[3-79]1"]],["(\\d{4})(\\d{3,6})","$1-$2",["1|3(?:0|[2-58]2)|4(?:0|[25]2|3[23]|[4689][25])|5(?:[02-578]2|6[25])|6(?:[0347-9]2|[26][25])|7[02-9]2|8(?:[023][23]|[4-7]2)|9(?:[02][23]|[458]2|6[016])"]],["(\\d{3})(\\d{3,7})","$1-$2",["[3-79][2-9]|8"]]],"0","0$1"],"BE":["32","[1-9]\\d{7,8}",[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4[6-9]"]],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[23]|4[23]|9[2-4]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[156]|7[018]|8(?:0[1-9]|[1-79])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"]]],"0","0$1"],"BF":["226","[25-7]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"BG":["359","[23567]\\d{5,7}|[489]\\d{6,8}",[["(2)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"]],["(2)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"]],["(\\d{3})(\\d{4})","$1 $2",["43[124-7]|70[1-9]"]],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[124-7]|70[1-9]"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[78]00"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["99[69]"]],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"]],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["48|8[7-9]|9[08]"]]],"0","0$1"],"BH":["973","[136-9]\\d{7}",[["(\\d{4})(\\d{4})","$1 $2"]]],"BI":["257","[267]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"BJ":["229","[2689]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"]]]],"BL":["590","[56]\\d{8}",[["([56]90)(\\d{2})(\\d{4})","$1 $2-$3",["[56]90"]]],"0",null,null,null,null,null,["590(?:2[7-9]|5[12]|87)\\d{4}","690(?:0[05-9]|[1-9]\\d)\\d{4}"]],"BM":["1","[4589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"441"],"BN":["673","[2-578]\\d{6}",[["([2-578]\\d{2})(\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","[23467]\\d{7}|8\\d{8}",[["([234])(\\d{7})","$1 $2",["[2-4]"]],["([67]\\d{7})","$1",["[67]"]],["(800)(\\d{2})(\\d{4})","$1 $2 $3",["800"]]],"0",null,"0(1\\d)?"],"BQ":["599","[347]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2",["[13-7]"]],["(9)(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],null,null,null,null,null,null,["(?:318[023]|41(?:6[023]|70)|7(?:1[578]|50)\\d)\\d{3}","(?:31(?:8[14-8]|9[14578])|416[145-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"]],"BR":["55","[1-46-9]\\d{7,10}|5(?:[0-4]\\d{7,9}|5(?:[2-8]\\d{7}|9\\d{7,8}))",[["(\\d{4})(\\d{4})","$1-$2",["300|40[02]","300|40(?:0|20)"]],["([3589]00)(\\d{2,3})(\\d{4})","$1 $2 $3",["[3589]00"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["[1-9][1-9]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[1-9][1-9]9"],"($1)"]],"0",null,"0(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","[2589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"242"],"BT":["975","[1-8]\\d{6,7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1|77"]],["([2-8])(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]]]],"BW":["267","[2-79]\\d{6,7}",[["(\\d{3})(\\d{4})","$1 $2",["[2-6]"]],["(7\\d)(\\d{3})(\\d{3})","$1 $2 $3",["7"]],["(90)(\\d{5})","$1 $2",["90"]]]],"BY":["375","[1-4]\\d{8}|8(?:0(?:0\\d{3,7}|[13]\\d{7})|(?:10|20\\d)\\d{7})|9\\d{9,10}",[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["17[0-3589]|2[4-9]|[34]","17(?:[02358]|1[0-2]|9[0189])|2[4-9]|[34]"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:5[24]|6[235]|7[467])|2(?:1[246]|2[25]|3[26])","1(?:5[24]|6(?:2|3[04-9]|5[0346-9])|7(?:[46]|7[37-9]))|2(?:1[246]|2[25]|3[26])"],"8 0$1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["([89]\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8[01]|9"],"8 $1"],["(82\\d)(\\d{4})(\\d{4})","$1 $2 $3",["82"],"8 $1"],["(800)(\\d{3})","$1 $2",["800"],"8 $1"],["(800)(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"]],"8",null,"8?0?"],"BZ":["501","[2-8]\\d{6}|0\\d{10}",[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(0)(800)(\\d{4})(\\d{3})","$1-$2-$3-$4",["080","0800"]]]],"CA":["1","[2-9]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,null,["(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:0[04]|13|22|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",null,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}","900[2-9]\\d{6}","5(?:00|22|33|44|66|77|88)[2-9]\\d{6}"]],"CC":["61","[1458]\\d{5,9}",[["([2378])(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|[45]"],"0$1"],["(16)(\\d{3,4})","$1 $2",["16"],"0$1"],["(16)(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(1[389]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1[389]0","1(?:[38]0|9)0"]],["(180)(2\\d{3})","$1 $2",["180","1802"]],["(19\\d)(\\d{3})","$1 $2",["19[13]"]],["(19\\d{2})(\\d{4})","$1 $2",["19[679]"]],["(13)(\\d{2})(\\d{2})","$1 $2 $3",["13[1-9]"]]],"0",null,null,null,null,null,["89162\\d{4}","14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12547-9]|9[017-9])\\d{6}","180(?:0\\d{3}|2)\\d{3}","19(?:0[0126]\\d|[679])\\d{5}","500\\d{6}",null,null,null,"550\\d{6}","13(?:00\\d{2})?\\d{4}"]],"CD":["243","[2-6]\\d{6}|[18]\\d{6,8}|9\\d{8}",[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["12"]],["([89]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8[0-2459]|9"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"]],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"]]],"0","0$1"],"CF":["236","[278]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"CG":["242","[028]\\d{8}",[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["801"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["800"]]]],"CH":["41","[2-9]\\d{8}|860\\d{9}",[["([2-9]\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]|[89]1"]],["([89]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["860"]]],"0","0$1"],"CI":["225","[02-8]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"CK":["682","[2-8]\\d{4}",[["(\\d{2})(\\d{3})","$1 $2"]]],"CL":["56","1230\\d{7}|[2-46-9]\\d{8,10}|5[1-3578]\\d{7}",[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[23]"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[357]|4[1-35]|6[13-57]"],"($1)"],["(9)(\\d{4})(\\d{4})","$1 $2 $3",["9"]],["(44)(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["([68]00)(\\d{3})(\\d{3,4})","$1 $2 $3",["[68]00"],"$1"],["(600)(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["600"],"$1"],["(1230)(\\d{3})(\\d{4})","$1 $2 $3",["123","1230"],"$1"],["(\\d{5})(\\d{4})","$1 $2",["219"],"($1)"]],"0","0$1","0|(1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))"],"CM":["237","[2368]\\d{7,8}",[["([26])(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[23]|88"]]]],"CN":["86","[1-7]\\d{6,11}|8[0-357-9]\\d{6,9}|9\\d{7,10}",[["(80\\d{2})(\\d{4})","$1 $2",["80[26-8]"],"0$1","true"],["([48]00)(\\d{3})(\\d{4})","$1 $2 $3",["[48]00"]],["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2\\d)[19]","(?:10|2\\d)(?:10|9[56])","(?:10|2\\d)(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["[3-9]","[3-9]\\d\\d[19]","[3-9]\\d\\d(?:10|9[56])"],"0$1"],["(21)(\\d{4})(\\d{4,6})","$1 $2 $3",["21"],"0$1","true"],["([12]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["10[1-9]|2[02-9]","10[1-9]|2[02-9]","10(?:[1-79]|8(?:0[1-9]|[1-9]))|2[02-9]"],"0$1","true"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[47-9]|7|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"],"0$1","true"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[457]|6[09])|8(?:[57]1|98)"],"0$1","true"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["807","8078"],"0$1","true"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1(?:[3-57-9]|66)"]],["(10800)(\\d{3})(\\d{4})","$1 $2 $3",["108","1080","10800"]],["(\\d{3})(\\d{7,8})","$1 $2",["950"]]],"0",null,"(1(?:[129]\\d{3}|79\\d{2}))|0"],"CO":["57","(?:[13]\\d{0,3}|[24-8])\\d{7}",[["(\\d)(\\d{7})","$1 $2",["1(?:[2-7]|8[2-9]|9[0-3])|[24-8]","1(?:[2-7]|8[2-9]|9(?:09|[1-3]))|[24-8]"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3"]],["(1)(\\d{3})(\\d{7})","$1-$2-$3",["1(?:80|9[04])","1(?:800|9(?:0[01]|4[78]))"],"0$1",null,"$1 $2 $3"]],"0",null,"0([3579]|4(?:44|56))?"],"CR":["506","[24-9]\\d{7,9}",[["(\\d{4})(\\d{4})","$1 $2",["[24-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]0"]]],null,null,"(19(?:0[012468]|1[09]|20|66|77|99))"],"CU":["53","[2-57]\\d{5,7}",[["(\\d)(\\d{6,7})","$1 $2",["7"]],["(\\d{2})(\\d{4,6})","$1 $2",["[2-4]"]],["(\\d)(\\d{7})","$1 $2",["5"],"0$1"]],"0","(0$1)"],"CV":["238","[259]\\d{6}",[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3"]]],"CW":["599","[134679]\\d{6,7}",[["(\\d{3})(\\d{4})","$1 $2",["[13-7]"]],["(9)(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],null,null,null,null,null,null,["9(?:[48]\\d{2}|50\\d|7(?:2[0-24]|[34]\\d|6[35-7]|77|8[7-9]))\\d{4}","9(?:5(?:[12467]\\d|3[01])|6(?:[15-9]\\d|3[01]))\\d{4}",null,null,null,null,null,"955\\d{5}",null,"60[0-2]\\d{4}"]],"CX":["61","[1458]\\d{5,9}",[["([2378])(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|[45]"],"0$1"],["(16)(\\d{3,4})","$1 $2",["16"],"0$1"],["(16)(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(1[389]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1[389]0","1(?:[38]0|9)0"]],["(180)(2\\d{3})","$1 $2",["180","1802"]],["(19\\d)(\\d{3})","$1 $2",["19[13]"]],["(19\\d{2})(\\d{4})","$1 $2",["19[679]"]],["(13)(\\d{2})(\\d{2})","$1 $2 $3",["13[1-9]"]]],"0",null,null,null,null,null,["89164\\d{4}","14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12547-9]|9[017-9])\\d{6}","180(?:0\\d{3}|2)\\d{3}","19(?:0[0126]\\d|[679])\\d{5}","500\\d{6}",null,null,null,"550\\d{6}","13(?:00\\d{2})?\\d{4}"]],"CY":["357","[257-9]\\d{7}",[["(\\d{2})(\\d{6})","$1 $2"]]],"CZ":["420","[2-8]\\d{8}|9\\d{8,11}",[["([2-9]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(96\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["96"]],["(9\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9[36]"]]]],"DE":["49","[1-35-9]\\d{3,14}|4(?:[0-8]\\d{3,12}|9(?:[0-37]\\d|4(?:[1-35-8]|4\\d?)|5\\d{1,2}|6[1-8]\\d?)\\d{2,8})",[["(1\\d{2})(\\d{7,8})","$1 $2",["1[67]"]],["(15\\d{3})(\\d{6})","$1 $2",["15[0568]"]],["(1\\d{3})(\\d{7})","$1 $2",["15"]],["(\\d{2})(\\d{3,11})","$1 $2",["3[02]|40|[68]9"]],["(\\d{3})(\\d{3,11})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14]|[4-9]1)|3(?:[35-9][15]|4[015])|[4-8][1-9]1|9(?:06|[1-9]1)"]],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|[7-9](?:0[1-9]|[1-9])","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|[46][1246]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|3[1357]|4[13578]|6[1246]|7[1356]|9[1346])|5(?:0[14]|2[1-3589]|3[1357]|[49][1246]|6[1-4]|7[1346]|8[13568])|6(?:0[356]|2[1-489]|3[124-6]|4[1347]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|3[1357]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|4[1347]|6[0135-9]|7[1467]|8[136])|9(?:0[12479]|2[1358]|3[1357]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|[7-9](?:0[1-9]|[1-9])"]],["(3\\d{4})(\\d{1,10})","$1 $2",["3"]],["(800)(\\d{7,12})","$1 $2",["800"]],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:37|80)|900","1(?:37|80)|900[1359]"]],["(1\\d{2})(\\d{5,11})","$1 $2",["181"]],["(18\\d{3})(\\d{6})","$1 $2",["185","1850","18500"]],["(18\\d{2})(\\d{7})","$1 $2",["18[68]"]],["(18\\d)(\\d{8})","$1 $2",["18[2-579]"]],["(700)(\\d{4})(\\d{4})","$1 $2 $3",["700"]],["(138)(\\d{4})","$1 $2",["138"]],["(15[013-68])(\\d{2})(\\d{8})","$1 $2 $3",["15[013-68]"]],["(15[279]\\d)(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"]],["(1[67]\\d)(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"]]],"0","0$1"],"DJ":["253","[27]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"DK":["45","[2-9]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"DM":["1","[57-9]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"767"],"DO":["1","[589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"8[024]9"],"DZ":["213","(?:[1-4]|[5-9]\\d)\\d{7}",[["([1-4]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"]],["([5-8]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"]],["(9\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"]]],"0","0$1"],"EC":["593","1\\d{9,10}|[2-8]\\d{7}|9\\d{8}",[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[247]|[356][2-8]"],null,null,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(1800)(\\d{3})(\\d{3,4})","$1 $2 $3",["180","1800"],"$1"]],"0","(0$1)"],"EE":["372","[3-9]\\d{6,7}|800\\d{6,7}",[["([3-79]\\d{2})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]"]],["(70)(\\d{2})(\\d{4})","$1 $2 $3",["70"]],["(8000)(\\d{3})(\\d{3})","$1 $2 $3",["800","8000"]],["([458]\\d{3})(\\d{3,4})","$1 $2",["40|5|8(?:00|[1-5])","40|5|8(?:00[1-9]|[1-5])"]]]],"EG":["20","1\\d{4,9}|[24-6]\\d{8}|3\\d{7}|[89]\\d{8,9}",[["(\\d)(\\d{7,8})","$1 $2",["[23]"]],["(\\d{2})(\\d{6,7})","$1 $2",["1(?:3|5[239])|[4-6]|[89][2-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1[0-25]|[89]00"]]],"0","0$1"],"EH":["212","[5-9]\\d{8}",[["([5-7]\\d{2})(\\d{6})","$1-$2",["5(?:2[015-7]|3[0-4])|[67]"]],["([58]\\d{3})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|92)|892","5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|924)|892"]],["(5\\d{4})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29|38)[89]"]],["([5]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:4[067]|5[03])"]],["(8[09])(\\d{7})","$1-$2",["8(?:0|9[013-9])"]]],"0",null,null,null,null,"528[89]"],"ER":["291","[178]\\d{6}",[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3"]],"0","0$1"],"ES":["34","[5-9]\\d{8}",[["([89]00)(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["([5-9]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[568]|[79][0-8]"]]]],"ET":["251","[1-59]\\d{8}",[["([1-59]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[1-59]"]]],"0","0$1"],"FI":["358","1\\d{5,9}|2\\d{4,9}|[35]\\d{5,9}|4\\d{5,10}|6\\d{6,9}|7\\d{7,9}|8\\d{6,8}|9\\d{4,8}",[["(\\d{3})(\\d{3,7})","$1 $2",["(?:[1-3]0|[6-8])0"]],["(116\\d{3})","$1",["116"],"$1"],["(\\d{2})(\\d{3,9})","$1 $2",["1(?:0[1-9]|[3-9])|2(?:0[1-9]|9)|30[1-9]|4|50|7(?:[13]|5[03-9])"]],["(\\d)(\\d{4})","$1 $2",["9[1-8]"]],["(\\d)(\\d{5,9})","$1 $2",["[235689][1-8]"]],["(39\\d)(\\d{3})(\\d{3})","$1 $2 $3",["39"]]],"0","0$1",null,null,null,null,["1[3-79][1-8]\\d{4,6}|[23568][1-8]\\d{5,7}|9[1-8]\\d{3,7}","4[0-8]\\d{5,8}|50\\d{4,8}","800\\d{5,6}","[67]00\\d{5,6}",null,null,"10(?:0\\d{4,6}|[1-37-9]\\d{5,7}|[46]\\d{3,7}|5\\d{4,7})|2(?:0(?:0\\d{4,6}|[1346-8]\\d{5,7}|2(?:[023]\\d{4,5}|[14-9]\\d{4,6})|5(?:\\d{3}|\\d{5,7})|9(?:[0-7]\\d{4,6}|[89]\\d{1,6}))|9\\d{5,8})|3(?:0(?:0\\d{3,7}|[1-57-9]\\d{5,7}|6(?:\\d{3}|\\d{5,7}))|44\\d{3}|93\\d{5,7})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{5,6})"]],"FJ":["679","[2-9]\\d{6}|0\\d{10}",[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]]],"FK":["500","[2-7]\\d{4}"],"FM":["691","[39]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"FO":["298","[2-9]\\d{5}",[["(\\d{6})","$1"]],null,null,"(10(?:01|[12]0|88))"],"FR":["33","[1-9]\\d{8}",[["([1-79])(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"]],["(8\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"]],"0","0$1"],"GA":["241","0?\\d{7}",[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]]]],"GB":["44","\\d{7,10}",[["(7\\d{3})(\\d{6})","$1 $2",["7(?:[1-57-9]|62)","7(?:[1-57-9]|624)"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:[02-9]1|1)|3|9[018]"]],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"]],["(1\\d{3})(\\d{5,6})","$1 $2",["1"]],["(800)(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"]],["(800)(\\d{6})","$1 $2",["800"]]],"0","0$1",null,null,null,null,["2(?:0[01378]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{7}|1(?:1(?:3[0-48]|[46][0-4]|5[0-26-9]|[78][0-49])|21[0-7]|31[0-8]|[4-69]1\\d)\\d{6}|1(?:2(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)|3(?:0\\d|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[28][02-57-9]|[37]\\d|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|2[024-9]|3[015689]|4[02-9]|5[03-9]|6\\d|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0124578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|8\\d|9[2-57]))\\d{6}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[345])))|3(?:638[2-5]|647[23]|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[123]))|5(?:24(?:3[2-79]|6\\d)|276\\d|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[567]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|955[0-4])|7(?:26(?:6[13-9]|7[0-7])|442\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|84(?:3[2-58]))|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}|176888[2-46-8]\\d{2}|16977[23]\\d{3}","7(?:[1-3]\\d{3}|4(?:[0-46-9]\\d{2}|5(?:[0-689]\\d|7[0-57-9]))|5(?:0[0-8]|[13-9]\\d|2[0-35-9])\\d|7(?:0(?:0[01]|[1-9]\\d)|[1-7]\\d{2}|8[02-9]\\d|9[0-689]\\d)|8(?:[014-9]\\d|[23][0-8])\\d|9(?:[024-9]\\d{2}|1(?:[02-9]\\d|1[028])|3[0-689]\\d))\\d{5}","80(?:0(?:1111|\\d{6,7})|8\\d{7})","(?:87[123]|9(?:[01]\\d|8[2349]))\\d{7}","70\\d{8}",null,"(?:3[0347]|55)\\d{8}","76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}","56\\d{8}","8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})"]],"GD":["1","[4589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"473"],"GE":["995","[34578]\\d{8}",[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5"]]],"0"],"GF":["594","[56]\\d{8}",[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],"0","0$1"],"GG":["44","[135789]\\d{6,9}",[["(7\\d{3})(\\d{6})","$1 $2",["7(?:[1-57-9]|62)","7(?:[1-57-9]|624)"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:[02-9]1|1)|3|9[018]"]],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"]],["(1\\d{3})(\\d{5,6})","$1 $2",["1"]],["(800)(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"]],["(800)(\\d{6})","$1 $2",["800"]]],"0",null,null,null,null,null,["1481[25-9]\\d{5}","7(?:781\\d|839\\d|911[17])\\d{5}","80(?:0(?:1111|\\d{6,7})|8\\d{7})","(?:87[123]|9(?:[01]\\d|8[0-3]))\\d{7}","70\\d{8}",null,"(?:3[0347]|55)\\d{8}","76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}","56\\d{8}","8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})"]],"GH":["233","[235]\\d{8}|8\\d{7}",[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{5})","$1 $2",["8"]]],"0","0$1"],"GI":["350","[256]\\d{7}",[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","[1-689]\\d{5}",[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3"]]],"GM":["220","[2-9]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"GN":["224","[367]\\d{7,8}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","[56]\\d{8}",[["([56]90)(\\d{2})(\\d{4})","$1 $2-$3",["[56]90"]]],"0","0$1",null,null,null,null,["590(?:0[13468]|1[012]|2[0-68]|3[28]|4[0-8]|5[579]|6[0189]|70|8[0-689]|9\\d)\\d{4}","690(?:0[05-9]|[1-9]\\d)\\d{4}"]],"GQ":["240","[23589]\\d{8}",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","[26-9]\\d{9}",[["([27]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["2[2-9]1|[689]"]],["(2\\d{3})(\\d{6})","$1 $2",["2[2-9][02-9]"]]]],"GT":["502","[2-7]\\d{7}|1[89]\\d{9}",[["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","[5689]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"671"],"GW":["245","(?:4(?:0\\d{5}|4\\d{7})|9\\d{8})",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["44|9[5-7]"]],["(\\d{3})(\\d{4})","$1 $2",["40"]]]],"GY":["592","[2-46-9]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"HK":["852","[2-7]\\d{7}|8[0-3]\\d{6,7}|9\\d{4,10}",[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|[89](?:0[1-9]|[1-9])"]],["(800)(\\d{3})(\\d{3})","$1 $2 $3",["800"]],["(900)(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["900"]],["(900)(\\d{2,5})","$1 $2",["900"]]]],"HN":["504","[237-9]\\d{7}",[["(\\d{4})(\\d{4})","$1-$2"]]],"HR":["385","[1-7]\\d{5,8}|[89]\\d{6,8}",[["(1)(\\d{4})(\\d{3})","$1 $2 $3",["1"]],["([2-5]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"]],["(9\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["9"]],["(6[01])(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"]],["([67]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[67]"]],["(80[01])(\\d{2})(\\d{2,3})","$1 $2 $3",["80[01]"]],["(80[01])(\\d{3})(\\d{3})","$1 $2 $3",["80[01]"]]],"0","0$1"],"HT":["509","[2-489]\\d{7}",[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3"]]],"HU":["36","[1-9]\\d{7,8}",[["(1)(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"]]],"06","($1)"],"ID":["62","(?:[1-79]\\d{6,10}|8\\d{7,11})",[["(\\d{2})(\\d{5,8})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,8})","$1 $2",["2[035-9]|[36][02-9]|[4579]"],"(0$1)"],["(8\\d{2})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"]],["(8\\d{2})(\\d{4})(\\d{4,5})","$1-$2-$3",["8[1-35-9]"]],["(1)(500)(\\d{3})","$1 $2 $3",["150","1500"],"$1"],["(177)(\\d{6,8})","$1 $2",["177"]],["(800)(\\d{5,7})","$1 $2",["800"]],["(804)(\\d{3})(\\d{4})","$1 $2 $3",["804"]],["(80\\d)(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80[79]"]]],"0","0$1"],"IE":["353","[124-9]\\d{6,9}",[["(1)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"]],["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"]],["(\\d{3})(\\d{5})","$1 $2",["40[24]|50[45]"]],["(48)(\\d{4})(\\d{4})","$1 $2 $3",["48"]],["(818)(\\d{3})(\\d{3})","$1 $2 $3",["818"]],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[24-69]|7[14]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["76|8[35-9]"],"0$1"],["(8\\d)(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8[35-9]5"],"0$1"],["(700)(\\d{3})(\\d{3})","$1 $2 $3",["700"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:5|8[059])","1(?:5|8[059]0)"],"$1"]],"0","(0$1)"],"IL":["972","1\\d{6,11}|[2-589]\\d{3}(?:\\d{3,6})?|6\\d{3}|7\\d{6,9}",[["([2-489])(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["([57]\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(153)(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["153"]],["(1)([7-9]\\d{2})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(1255)(\\d{3})","$1-$2",["125","1255"]],["(1200)(\\d{3})(\\d{3})","$1-$2-$3",["120","1200"]],["(1212)(\\d{2})(\\d{2})","$1-$2-$3",["121","1212"]],["(1599)(\\d{6})","$1-$2",["159","1599"]],["(151)(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["151"]],["(\\d{4})","*$1",["[2-689]"]]],"0"],"IM":["44","[135789]\\d{6,9}",[["(7\\d{3})(\\d{6})","$1 $2",["7(?:[1-57-9]|62)","7(?:[1-57-9]|624)"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:[02-9]1|1)|3|9[018]"]],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"]],["(1\\d{3})(\\d{5,6})","$1 $2",["1"]],["(800)(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"]],["(800)(\\d{6})","$1 $2",["800"]]],"0",null,null,null,null,null,["1624[5-8]\\d{5}","7(?:4576|[59]24\\d|624[0-4689])\\d{5}","808162\\d{4}","(?:872299|90[0167]624)\\d{4}","70\\d{8}",null,"3(?:08162\\d|3\\d{5}|4(?:40[49]06|5624\\d)|7(?:0624\\d|2299\\d))\\d{3}|55\\d{8}",null,"56\\d{8}","8(?:4(?:40[49]06|5624\\d)|70624\\d)\\d{3}"]],"IN":["91","008\\d{9}|1\\d{7,12}|[2-9]\\d{9,10}",[["(\\d{8})","$1",["561","5616","56161"],"$1"],["(\\d{5})(\\d{5})","$1 $2",["6(?:[09]0|28|3[589])|7(?:[02-8]|19|9[037-9])|8(?:0[015-9]|[1-9])|9","6(?:[09]0|28[0-2]|3(?:5[01]|[89]0))|7(?:[07]|19[0-5]|2(?:[0235-9]|[14][017-9])|3(?:[025-9]|[134][017-9])|4(?:[0-35689]|[47][017-9])|5(?:[02-46-9]|[15][017-9])|6(?:[02-9]|1[0-257-9])|8(?:[0-79]|8[0189])|9(?:[089]|31|7[02-9]))|8(?:0(?:[01589]|6[67]|7[02-9])|1(?:[0-57-9]|6[07-9])|2(?:[014][07-9]|[235-9])|3(?:[03-57-9]|[126][07-9])|[45]|6(?:[02457-9]|[136][07-9])|7(?:[078][07-9]|[1-69])|8(?:[0-25-9]|3[07-9]|4[047-9])|9(?:[02-9]|1[027-9]))|9","6(?:[09]0|28[0-2]|3(?:5(?:0[0-6]|1)|[89]0))|7(?:0|19[0-5]|2(?:[0235-79]|[14][017-9]|8(?:[0-69]|[78][089]))|3(?:[05-8]|1(?:[0189]|7[5-9])|2(?:[0-49][089]|[5-8])|3[017-9]|4(?:[07-9]|11)|9(?:[01689]|[2-5][089]|7[0189]))|4(?:[056]|1(?:[0135-9]|[24][089])|[29](?:[0-7][089]|[89])|3(?:[0-8][089]|9)|[47](?:[089]|11|7[02-8])|8(?:[0-24-7][089]|[389]))|5(?:[0346-9]|[15][017-9]|2(?:[03-9]|[12][089]))|6(?:[0346-9]|1[0-257-9]|2(?:[0-4]|[5-9][089])|5(?:[0-367][089]|[4589]))|7(?:0(?:[02-9]|1[089])|[1-9])|8(?:[0-79]|8(?:0[0189]|11|8[013-9]|9))|9(?:[089]|313|7(?:[02-8]|9[07-9])))|8(?:0(?:[01589]|6[67]|7(?:[02-8]|9[05-9]))|1(?:[02-57-9]|1(?:[0-35-9]|4[0-46-9])|6(?:[089]|7[02-8]))|2(?:0(?:[089]|7[02])|[14](?:[089]|7[02-8])|[235-9])|3(?:[03-57-9]|1(?:[089]|7[02-6])|2(?:[09]|77|8[0-689])|6(?:[089]|7[02-7]))|[45]|6(?:[02457-9]|[136](?:[089]|7[02-8]))|7(?:0[07-9]|[1-69]|[78](?:[089]|7[02-8]))|8(?:[0-25-9]|3(?:[089]|7[02-8])|4(?:[0489]|7[02-68]))|9(?:[02-9]|1(?:[0289]|7[2-6])))|9"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-9]|80[2-46]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[59][14]|[68][1-9]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1|9[15])|6(?:12|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[23579]|[468][1-9])|[2-8]"]],["(\\d{2})(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3 $4",["008"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],"$1"],["(\\d{4})(\\d{2})(\\d{4})","$1 $2 $3",["160","1600"],"$1"],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],"$1"],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["180","1800"],"$1"],["(\\d{4})(\\d{3,4})(\\d{4})","$1 $2 $3",["186","1860"],"$1"],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18[06]"],"$1"]],"0","0$1",null,null,true],"IO":["246","3\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"IQ":["964","[1-7]\\d{7,9}",[["(1)(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["([2-6]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"]],["(7\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"]]],"0","0$1"],"IR":["98","[1-8]\\d{5,9}|9(?:[0-4]\\d{8}|9\\d{8})",[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"]],["(\\d{2})(\\d{4,5})","$1 $2",["[1-8]"]],["(\\d{4,5})","$1",["96"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"]]],"0","0$1"],"IS":["354","[4-9]\\d{6}|38\\d{7}",[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(3\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]]],"IT":["39","[01589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9})",[["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|55"]],["(0[26])(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(0[26])(\\d{4,6})","$1 $2",["0[26]"]],["(0\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[245])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]],["(0\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["0[13-57-9][2-46-8]"]],["(0\\d{3})(\\d{2,6})","$1 $2",["0[13-57-9][2-46-8]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13]|8(?:00|4[08]|9[59])","[13]|8(?:00|4[08]|9(?:5[5-9]|9))"]],["(\\d{4})(\\d{4})","$1 $2",["894","894[5-9]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["3"]]],null,null,null,null,null,null,["0(?:[26]\\d{4,9}|(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2346]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[34578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7})","3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})","80(?:0\\d{6}|3\\d{3})","0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})","1(?:78\\d|99)\\d{6}",null,null,null,"55\\d{8}","84(?:[08]\\d{6}|[17]\\d{3})"]],"JE":["44","[135789]\\d{6,9}",[["(7\\d{3})(\\d{6})","$1 $2",["7(?:[1-57-9]|62)","7(?:[1-57-9]|624)"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:[02-9]1|1)|3|9[018]"]],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"]],["(1\\d{3})(\\d{5,6})","$1 $2",["1"]],["(800)(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"]],["(800)(\\d{6})","$1 $2",["800"]]],"0",null,null,null,null,null,["1534[0-24-8]\\d{5}","7(?:509\\d|7(?:00[378]|97[7-9])|829\\d|937\\d)\\d{5}","80(?:07(?:35|81)|8901)\\d{4}","(?:871206|90(?:066[59]|1810|71(?:07|55)))\\d{4}","701511\\d{4}",null,"3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))\\d{4}|55\\d{8}","76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}","56\\d{8}","8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|70002)\\d{4}"]],"JM":["1","[589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"876"],"JO":["962","[235-9]\\d{7,8}",[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(7)(\\d{4})(\\d{4})","$1 $2 $3",["7[457-9]"]],["(\\d{2})(\\d{7})","$1 $2",["70"]],["(\\d{3})(\\d{5,6})","$1 $2",["8[0158]|9"]]],"0","0$1"],"JP":["81","[1-9]\\d{8,9}|00(?:[36]\\d{7,14}|7\\d{5,7}|8\\d{7})",[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"]],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[2579]0|80[1-9]"]],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])","1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[78]|96)|477|51[24]|636)|9(?:496|802|9(?:1[23]|69))","1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[78]|96[2457-9])|477|51[24]|636[2-57-9])|9(?:496|802|9(?:1[23]|69))"]],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:[3-6][2-9]|7[2-6]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|4[2-69]|[5-7]))","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6[56]))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))","1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6(?:5[25]|60)))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"]],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93)","1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93[34])","1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93(?:31|4))"]],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["2(?:[34]7|[56]9|74|9[14-79])|82|993"]],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["3|4(?:2[09]|7[01])|6[1-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[2479][1-9]"]]],"0","0$1"],"KE":["254","20\\d{6,7}|[4-9]\\d{6,9}",[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"]],["(\\d{3})(\\d{6})","$1 $2",["7"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"]]],"0","0$1","005|0"],"KG":["996","[235-8]\\d{8,9}",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[25-7]|31[25]"]],["(\\d{4})(\\d{5})","$1 $2",["3(?:1[36]|[2-9])"]],["(\\d{3})(\\d{3})(\\d)(\\d{3})","$1 $2 $3 $4",["8"]]],"0","0$1"],"KH":["855","[1-9]\\d{7,9}",[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["1\\d[1-9]|[2-9]"],"0$1"],["(1[89]00)(\\d{3})(\\d{3})","$1 $2 $3",["1[89]0","1[89]00"]]],"0"],"KI":["686","[2458]\\d{4}|3\\d{4,7}|[67]\\d{7}",[],null,null,"0"],"KM":["269","[3478]\\d{6}",[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3"]]],"KN":["1","[589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"869"],"KP":["850","1\\d{9}|[28]\\d{7}",[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],"0","0$1"],"KR":["82","00(?:3\\d{8,9}|7\\d{9,11})|[1-7]\\d{4,9}|8\\d{8}",[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"]],["(\\d{4})(\\d{4})","$1-$2",["1(?:5[246-9]|6[046-8]|8[03579])","1(?:5(?:22|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))"],"$1"],["(\\d{5})","$1",["1[016-9]1","1[016-9]11","1[016-9]114"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2[1-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60[2-9]|80"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["1[0-25-9]|(?:3[1-3]|[46][1-4]|5[1-5])[1-9]"]],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]0"]]],"0","0$1","0(8[1-46-8]|85\\d{2})?"],"KW":["965","[12569]\\d{6,7}",[["(\\d{4})(\\d{3,4})","$1 $2",["[16]|2(?:[0-35-9]|4[0-35-9])|52[25]|9[024-9]"]],["(\\d{3})(\\d{5})","$1 $2",["244|5(?:[015]|6[56])"]]]],"KY":["1","[3589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"345"],"KZ":["7","(?:33\\d|7\\d{2}|80[089])\\d{7}",[["([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[3489]"]],["(7\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"]]],"8",null,null,null,null,null,["33622\\d{5}|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[234]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[234]\\d|5[139])|4(?:2\\d|3[1235-9]|59)|5(?:[23]\\d|4[01246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59)))\\d{5}","7(?:0[012578]|47|6[02-4]|7[15-8]|85)\\d{7}","800\\d{7}","809\\d{7}","808\\d{7}",null,null,null,"751\\d{7}"]],"LA":["856","[2-8]\\d{7,9}",[["(20)(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["20"]],["([2-8]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"]],["(30)(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30"]]],"0","0$1"],"LB":["961","[13-9]\\d{6,7}",[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["([7-9]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["7(?:[01]|6[013-9]|8[89]|9[1-3])|[89][01]"]]],"0"],"LC":["1","[5789]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"758"],"LI":["423","6\\d{8}|[23789]\\d{6}",[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[237-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[56]"]],["(69)(7\\d{2})(\\d{4})","$1 $2 $3",["697"]]],"0",null,"0|10(?:01|20|66)"],"LK":["94","[1-9]\\d{8}",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"]]],"0","0$1"],"LR":["231","2\\d{7,8}|[378]\\d{8}|4\\d{6}|5\\d{6,8}",[["(2\\d)(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["([4-5])(\\d{3})(\\d{3})","$1 $2 $3",["[45]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23578]"]]],"0","0$1"],"LS":["266","[2568]\\d{7}",[["(\\d{4})(\\d{4})","$1 $2"]]],"LT":["370","[3-9]\\d{7}",[["([34]\\d)(\\d{6})","$1 $2",["37|4(?:1|5[45]|6[2-4])"]],["([3-6]\\d{2})(\\d{5})","$1 $2",["3[148]|4(?:[24]|6[09])|528|6"]],["([7-9]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1"],["(5)(2\\d{2})(\\d{4})","$1 $2 $3",["52[0-79]"]]],"8","(8-$1)","[08]",null,true],"LU":["352","[24-9]\\d{3,10}|3(?:[0-46-9]\\d{2,9}|5[013-9]\\d{1,8})",[["(\\d{2})(\\d{3})","$1 $2",["[2-5]|7[1-9]|[89](?:0[2-9]|[1-9])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[2-5]|7[1-9]|[89](?:0[2-9]|[1-9])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,4})","$1 $2 $3 $4",["2(?:[12589]|4[12])|[3-5]|7[1-9]|8(?:0[2-9]|[1-9])|9(?:0[2-46-9]|[1-9])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["70|80[01]|90[015]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],null,null,"(15(?:0[06]|1[12]|35|4[04]|55|6[26]|77|88|99)\\d)"],"LV":["371","[2689]\\d{7}",[["([2689]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2689]"]]]],"LY":["218","[25679]\\d{8}",[["([25-79]\\d)(\\d{7})","$1-$2",["[25-79]"]]],"0","0$1"],"MA":["212","[5-9]\\d{8}",[["([5-7]\\d{2})(\\d{6})","$1-$2",["5(?:2[015-7]|3[0-4])|[67]"]],["([58]\\d{3})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|92)|892","5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|924)|892"]],["(5\\d{4})(\\d{4})","$1-$2",["5(?:29|38)","5(?:29|38)[89]"]],["([5]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:4[067]|5[03])"]],["(8[09])(\\d{7})","$1-$2",["8(?:0|9[013-9])"]]],"0","0$1",null,null,null,null,["5(?:2(?:[015-79]\\d|2[02-9]|3[2-57]|4[2-8]|8[235-7])\\d|3(?:[0-48]\\d|[57][2-9]|6[2-8]|9[3-9])\\d|4[067]\\d{2}|5[03]\\d{2})\\d{4}","(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[067]|6[1267]|7[07]))\\d{6}","80\\d{7}","89\\d{7}",null,null,null,null,"5924[01]\\d{4}"]],"MC":["377","[34689]\\d{7,8}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[39]"],"$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"]],["(6)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"]],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["8"],"$1"]],"0","0$1"],"MD":["373","[235-9]\\d{7}",[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"]],["([25-7]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["2[13-9]|[5-7]"]],["([89]\\d{2})(\\d{5})","$1 $2",["[89]"]]],"0","0$1"],"ME":["382","[2-9]\\d{7,8}",[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]|6[036-9]"]]],"0","0$1"],"MF":["590","[56]\\d{8}",[["([56]90)(\\d{2})(\\d{4})","$1 $2-$3",["[56]90"]]],"0",null,null,null,null,null,["590(?:[02][79]|13|5[0-268]|[78]7)\\d{4}","690(?:0[05-9]|[1-9]\\d)\\d{4}"]],"MG":["261","[23]\\d{8}",[["([23]\\d)(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"]]],"0","0$1"],"MH":["692","[2-6]\\d{6}",[["(\\d{3})(\\d{4})","$1-$2"]],"1"],"MK":["389","[2-578]\\d{7}",[["(2)(\\d{3})(\\d{4})","$1 $2 $3",["2"]],["([347]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[347]"]],["([58]\\d{2})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"]]],"0","0$1"],"ML":["223","[246-9]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[246-9]"]]]],"MM":["95","[178]\\d{5,7}|[24-6]\\d{5,8}|9(?:[279]\\d{0,2}|5|[34]\\d{1,2}|6(?:\\d{1,2})?|8(?:\\d{2})?)\\d{6}",[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["1|2[245]"]],["(2)(\\d{4})(\\d{4})","$1 $2 $3",["251"]],["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"]],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["432|67|81"]],["(\\d{2})(\\d{2})(\\d{3,4})","$1 $2 $3",["[4-8]"]],["(9)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"]],["(9)([34]\\d{4})(\\d{4})","$1 $2 $3",["9(?:3[0-36]|4[0-57-9])"]],["(9)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92[56]"]],["(9)(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["93"]]],"0","0$1"],"MN":["976","[12]\\d{7,9}|[57-9]\\d{7}",[["([12]\\d)(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"]],["([12]2\\d)(\\d{5,6})","$1 $2",["[12]2[1-3]"]],["([12]\\d{3})(\\d{5})","$1 $2",["[12](?:27|[3-5])","[12](?:27|[3-5]\\d)2"]],["(\\d{4})(\\d{4})","$1 $2",["[57-9]"],"$1"],["([12]\\d{4})(\\d{4,5})","$1 $2",["[12](?:27|[3-5])","[12](?:27|[3-5]\\d)[4-9]"]]],"0","0$1"],"MO":["853","[268]\\d{7}",[["([268]\\d{3})(\\d{4})","$1 $2",["[268]"]]]],"MP":["1","[5689]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"670"],"MQ":["596","[56]\\d{8}",[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]],"0","0$1"],"MR":["222","[2-48]\\d{7}",[["([2-48]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","[5689]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"664"],"MT":["356","[2357-9]\\d{7}",[["(\\d{4})(\\d{4})","$1 $2"]]],"MU":["230","[2-9]\\d{6,7}",[["([2-46-9]\\d{2})(\\d{4})","$1 $2",["[2-46-9]"]],["(5\\d{3})(\\d{4})","$1 $2",["5"]]]],"MV":["960","[346-8]\\d{6,9}|9(?:00\\d{7}|\\d{6})",[["(\\d{3})(\\d{4})","$1-$2",["[3467]|9(?:0[1-9]|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]00"]]]],"MW":["265","(?:1(?:\\d{2})?|[2789]\\d{2})\\d{6}",[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(2\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[17-9]"]]],"0","0$1"],"MX":["52","[1-9]\\d{9,10}",[["([358]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["33|55|81"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2467]|3[0-2457-9]|5[089]|8[02-9]|9[0-35-9]"]],["(1)([358]\\d)(\\d{4})(\\d{4})","044 $2 $3 $4",["1(?:33|55|81)"],"$1",null,"$1 $2 $3 $4"],["(1)(\\d{3})(\\d{3})(\\d{4})","044 $2 $3 $4",["1(?:[2467]|3[0-2457-9]|5[089]|8[2-9]|9[1-35-9])"],"$1",null,"$1 $2 $3 $4"]],"01","01 $1","0[12]|04[45](\\d{10})","1$1",true],"MY":["60","[13-9]\\d{7,9}",[["([4-79])(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(3)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["([18]\\d)(\\d{3})(\\d{3,4})","$1-$2 $3",["1[02-46-9][1-9]|8"],"0$1"],["(1)([36-8]00)(\\d{2})(\\d{4})","$1-$2-$3-$4",["1[36-8]0","1[36-8]00"]],["(11)(\\d{4})(\\d{4})","$1-$2 $3",["11"],"0$1"],["(15[49])(\\d{3})(\\d{4})","$1-$2 $3",["15[49]"],"0$1"]],"0"],"MZ":["258","[28]\\d{7,8}",[["([28]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-7]"]],["(80\\d)(\\d{3})(\\d{3})","$1 $2 $3",["80"]]]],"NA":["264","[68]\\d{7,8}",[["(8\\d)(\\d{3})(\\d{4})","$1 $2 $3",["8[1-35]"]],["(6\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["6"]],["(88)(\\d{3})(\\d{3})","$1 $2 $3",["88"]],["(870)(\\d{3})(\\d{3})","$1 $2 $3",["870"]]],"0","0$1"],"NC":["687","[2-57-9]\\d{5}",[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[2-46-9]|5[0-4]"]]]],"NE":["227","[0289]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["09|[289]"]],["(08)(\\d{3})(\\d{3})","$1 $2 $3",["08"]]]],"NF":["672","[13]\\d{5}",[["(\\d{2})(\\d{4})","$1 $2",["1"]],["(\\d)(\\d{5})","$1 $2",["3"]]]],"NG":["234","[1-6]\\d{5,8}|9\\d{5,9}|[78]\\d{5,13}",[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"]],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-6]|7(?:0[1-9]|[1-79])|8[2-9]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["70|8[01]|90[235-9]"]],["([78]00)(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]00"]],["([78]00)(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]00"]],["(78)(\\d{2})(\\d{3})","$1 $2 $3",["78"]]],"0","0$1"],"NI":["505","[125-8]\\d{7}",[["(\\d{4})(\\d{4})","$1 $2"]]],"NL":["31","1\\d{4,8}|[2-7]\\d{8}|[89]\\d{6,9}",[["([1-578]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1[035]|2[0346]|3[03568]|4[0356]|5[0358]|7|8[4578]"]],["([1-5]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"]],["(6)(\\d{8})","$1 $2",["6[0-57-9]"]],["(66)(\\d{7})","$1 $2",["66"]],["(14)(\\d{3,4})","$1 $2",["14"],"$1"],["([89]0\\d)(\\d{4,7})","$1 $2",["[89]0"]]],"0","0$1"],"NO":["47","0\\d{4}|[2-9]\\d{7}",[["([489]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[489]"]],["([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],null,null,null,null,null,null,["(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}","(?:4[015-8]|5[89]|87|9\\d)\\d{6}","80[01]\\d{5}","82[09]\\d{5}","880\\d{5}",null,"0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}",null,"85[0-5]\\d{5}","810(?:0[0-6]|[2-8]\\d)\\d{3}"]],"NP":["977","[1-8]\\d{7}|9(?:[1-69]\\d{6,8}|7[2-6]\\d{5,7}|8\\d{8})",[["(1)(\\d{7})","$1-$2",["1[2-6]"]],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-69]|7[15-9])"]],["(9\\d{2})(\\d{7})","$1-$2",["9(?:6[013]|7[245]|8)"],"$1"]],"0","0$1"],"NR":["674","[458]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"NU":["683","[1-5]\\d{3}"],"NZ":["64","6[235-9]\\d{6}|[2-57-9]\\d{7,9}",[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["240|[346]|7[2-57-9]|9[1-9]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["21"]],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:1[1-9]|[69]|7[0-35-9])|70|86"]],["(2\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["2[028]"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["90"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|5|[89]0"]]],"0","0$1"],"OM":["968","(?:5|[279]\\d)\\d{6}|800\\d{5,6}",[["(2\\d)(\\d{6})","$1 $2",["2"]],["([79]\\d{3})(\\d{4})","$1 $2",["[79]"]],["([58]00)(\\d{4,6})","$1 $2",["[58]00"]]]],"PA":["507","[1-9]\\d{6,7}",[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["6"]]]],"PE":["51","[14-9]\\d{7,8}",[["(1)(\\d{7})","$1 $2",["1"]],["([4-8]\\d)(\\d{6})","$1 $2",["[4-7]|8[2-4]"]],["(\\d{3})(\\d{5})","$1 $2",["80"]],["(9\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"$1"]],"0","(0$1)"],"PF":["689","4\\d{5,7}|8\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4[09]|8[79]"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]]]],"PG":["675","[1-9]\\d{6,7}",[["(\\d{3})(\\d{4})","$1 $2",["[13-689]|27"]],["(\\d{4})(\\d{4})","$1 $2",["20|7"]]]],"PH":["63","1\\d{10,12}|2\\d{5,7}|[3-7]\\d{8}|8\\d{7,9}|9\\d{9}",[["(2)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(2)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|5(?:22|44)|642|8(?:62|8[245])","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["([3-8]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[3-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["81|9"],"0$1"],["(1800)(\\d{3})(\\d{4})","$1 $2 $3",["180","1800"]],["(1800)(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["180","1800"]]],"0"],"PK":["92","1\\d{8}|[2-8]\\d{5,11}|9(?:[013-9]\\d{4,10}|2\\d(?:111\\d{6}|\\d{3,7}))",[["([89]00)(\\d{3})(\\d{2})","$1 $2 $3",["[89]00"],"0$1"],["(1\\d{3})(\\d{5})","$1 $2",["1"],"$1"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"]],["(\\d{3})(\\d{6,7})","$1 $2",["2[349]|45|54|60|72|8[2-5]|9[2-469]","(?:2[349]|45|54|60|72|8[2-5]|9[2-469])\\d[2-9]"]],["(58\\d{3})(\\d{5})","$1 $2",["58[126]"]],["(3\\d{2})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(111)(\\d{3})(\\d{3})","$1 $2 $3 $4",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)1","(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)11","(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)111"]],["(\\d{3})(111)(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[349]|45|54|60|72|8[2-5]|9[2-9]","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d1","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d11","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d111"]]],"0","(0$1)"],"PL":["48","[1-57-9]\\d{6,8}|6\\d{5,8}",[["(\\d{3})(\\d{3})","$1 $2",["11[68]|64"]],["(\\d{5})","$1",["19"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["26|39|45|5[0137]|6[0469]|7[02389]|8[08]"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[14]|2[0-57-9]|3[2-4]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"]]]],"PM":["508","[45]\\d{5}",[["([45]\\d)(\\d{2})(\\d{2})","$1 $2 $3",["[45]"]]],"0","0$1"],"PR":["1","[5789]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"787|939"],"PS":["970","1\\d{9}|[24589]\\d{7,8}",[["([2489])(2\\d{2})(\\d{4})","$1 $2 $3",["[2489]2"]],["(5[69]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["5[69]"]],["(1[78]00)(\\d{3})(\\d{3})","$1 $2 $3",["1[78]0","1[78]00"],"$1"]],"0","0$1"],"PT":["351","[2-46-9]\\d{8}",[["(2\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["([2-46-9]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[3-9]|[346-9]"]]]],"PW":["680","[2-8]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"PY":["595","5[0-5]\\d{4,7}|[2-46-9]\\d{5,8}",[["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["9[1-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["870","8700"]],["(\\d{3})(\\d{4,5})","$1 $2",["[2-8][1-9]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8][1-9]"],"0$1"]],"0"],"QA":["974","[2-8]\\d{6,7}",[["([28]\\d{2})(\\d{4})","$1 $2",["[28]"]],["([3-7]\\d{3})(\\d{4})","$1 $2",["[3-7]"]]]],"RE":["262","[268]\\d{8}",[["([268]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[268]"]]],"0","0$1",null,null,null,"262|69|8"],"RO":["40","[23]\\d{5,8}|[7-9]\\d{8}",[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"]],["(\\d{2})(\\d{4})","$1 $2",["[23]1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23][3-7]|[7-9]"]],["(2\\d{2})(\\d{3})","$1 $2",["2[3-6]"]]],"0","0$1"],"RS":["381","[126-9]\\d{4,11}|3(?:[0-79]\\d{3,10}|8[2-9]\\d{2,9})",[["([23]\\d{2})(\\d{4,9})","$1 $2",["(?:2[389]|39)0"]],["([1-3]\\d)(\\d{5,10})","$1 $2",["1|2(?:[0-24-7]|[389][1-9])|3(?:[0-8]|9[1-9])"]],["(6\\d)(\\d{6,8})","$1 $2",["6"]],["([89]\\d{2})(\\d{3,9})","$1 $2",["[89]"]],["(7[26])(\\d{4,9})","$1 $2",["7[26]"]],["(7[08]\\d)(\\d{4,9})","$1 $2",["7[08]"]]],"0","0$1"],"RU":["7","[347-9]\\d{9}",[["([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[3489]"]],["(7\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"]]],"8","8 ($1)",null,null,true,null,["(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}","9\\d{9}","80[04]\\d{7}","80[39]\\d{7}","808\\d{7}"]],"RW":["250","[027-9]\\d{7,8}",[["(2\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["([7-9]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"],["(0\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]]],"0"],"SA":["966","1\\d{7,8}|(?:[2-467]|92)\\d{7}|5\\d{8}|8\\d{9}",[["([1-467])(\\d{3})(\\d{4})","$1 $2 $3",["[1-467]"]],["(1\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1[1-467]"]],["(5\\d)(\\d{3})(\\d{4})","$1 $2 $3",["5"]],["(92\\d{2})(\\d{5})","$1 $2",["92"],"$1"],["(800)(\\d{3})(\\d{4})","$1 $2 $3",["800"],"$1"],["(811)(\\d{3})(\\d{3,4})","$1 $2 $3",["811"]]],"0","0$1"],"SB":["677","[1-9]\\d{4,6}",[["(\\d{2})(\\d{5})","$1 $2",["[7-9]"]]]],"SC":["248","[24689]\\d{5,6}",[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]"]]]],"SD":["249","[19]\\d{8}",[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3"]],"0","0$1"],"SE":["46","[1-35-9]\\d{5,11}|4\\d{6,8}",[["(8)(\\d{2,3})(\\d{2,3})(\\d{2})","$1-$2 $3 $4",["8"],null,null,"$1 $2 $3 $4"],["([1-69]\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"],null,null,"$1 $2 $3 $4"],["([1-469]\\d)(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90"],null,null,"$1 $2 $3"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"],null,null,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"],null,null,"$1 $2 $3"],["(7\\d)(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["7"],null,null,"$1 $2 $3 $4"],["(77)(\\d{2})(\\d{2})","$1-$2$3",["77"],null,null,"$1 $2 $3"],["(20)(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],null,null,"$1 $2 $3"],["(9[034]\\d)(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9[034]"],null,null,"$1 $2 $3 $4"],["(9[034]\\d)(\\d{4})","$1-$2",["9[034]"],null,null,"$1 $2"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["25[245]|67[3-6]"],null,null,"$1 $2 $3 $4 $5"]],"0","0$1"],"SG":["65","[36]\\d{7}|[17-9]\\d{7,10}",[["([3689]\\d{3})(\\d{4})","$1 $2",["[369]|8[1-9]"]],["(1[89]00)(\\d{3})(\\d{4})","$1 $2 $3",["1[89]0","1[89]00"]],["(7000)(\\d{4})(\\d{3})","$1 $2 $3",["700","7000"]],["(800)(\\d{3})(\\d{4})","$1 $2 $3",["800"]]]],"SH":["290","[256]\\d{4}|8\\d{3}",[],null,null,null,null,null,null,["2(?:[0-57-9]\\d|6[4-9])\\d{2}","[56]\\d{4}",null,null,null,null,null,null,"262\\d{2}"]],"SI":["386","[1-7]\\d{6,7}|[89]\\d{4,7}",[["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[12]|[34][24-8]|5[2-8]|7[3-8]"],"(0$1)"],["([3-7]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"]],["([89][09])(\\d{3,6})","$1 $2",["[89][09]"]],["([58]\\d{2})(\\d{5})","$1 $2",["59|8[1-3]"]]],"0","0$1"],"SJ":["47","0\\d{4}|[45789]\\d{7}",[["([489]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[489]"]],["([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],null,null,null,null,null,null,["79\\d{6}","(?:4[015-8]|5[89]|9\\d)\\d{6}","80[01]\\d{5}","82[09]\\d{5}","880\\d{5}",null,"0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}",null,"85[0-5]\\d{5}","810(?:0[0-6]|[2-8]\\d)\\d{3}"]],"SK":["421","(?:[2-68]\\d{5,8}|9\\d{6,8})",[["(2)(1[67])(\\d{3,4})","$1 $2 $3",["21[67]"]],["([3-5]\\d)(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5]"]],["(2)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"]],["([3-5]\\d)(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"]],["([689]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"]],["(9090)(\\d{3})","$1 $2",["909","9090"]]],"0","0$1"],"SL":["232","[2-9]\\d{7}",[["(\\d{2})(\\d{6})","$1 $2"]],"0","(0$1)"],"SM":["378","[05-7]\\d{7,9}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(0549)(\\d{6})","$1 $2",["054","0549"],null,null,"($1) $2"],["(\\d{6})","0549 $1",["[89]"],null,null,"(0549) $1"]],null,null,"([89]\\d{5})","0549$1"],"SN":["221","[3789]\\d{8}",[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"SO":["252","[1-9]\\d{5,8}",[["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[13-5]|2[0-79]"]],["(\\d)(\\d{7})","$1 $2",["24|[67]"]],["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{2})(\\d{5,7})","$1 $2",["15|28|6[1-35-9]|799|9[2-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3[59]|4[89]|6[24-6]|79|8[08]|90"]]],"0"],"SR":["597","[2-8]\\d{5,6}",[["(\\d{3})(\\d{3})","$1-$2",["[2-4]|5[2-58]"]],["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","[19]\\d{8}",[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",null,"0$1"]],"0"],"ST":["239","[29]\\d{6}",[["(\\d{3})(\\d{4})","$1 $2"]]],"SV":["503","[267]\\d{7}|[89]\\d{6}(?:\\d{4})?",[["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","[5789]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"721"],"SY":["963","[1-59]\\d{7,8}",[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"]],["(9\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0","0$1",null,null,true],"SZ":["268","[027]\\d{7}",[["(\\d{4})(\\d{4})","$1 $2",["[027]"]]]],"TA":["290","8\\d{3}",[],null,null,null,null,null,null,["8\\d{3}"]],"TC":["1","[5689]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"649"],"TD":["235","[2679]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4"]]],"TG":["228","[29]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[29]"]]]],"TH":["66","1\\d{8,9}|[2-9]\\d{7,8}",[["(2)(\\d{3})(\\d{4})","$1 $2 $3",["2"]],["([13-9]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["14|[3-9]"]],["(1[89]00)(\\d{3})(\\d{3})","$1 $2 $3",["1[89]0","1[89]00"],"$1"]],"0","0$1"],"TJ":["992","[3-57-9]\\d{8}",[["([349]\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[34]7|91[78]"]],["([457-9]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[148]|[578]|9(?:[0235-9]|1[59])"]],["(331700)(\\d)(\\d{2})","$1 $2 $3",["331","3317","33170","331700"]],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]","3(?:[1245]|3(?:[02-9]|1[0-589]))"]]],"8",null,null,null,true],"TK":["690","[2-47]\\d{3,6}"],"TL":["670","[2-489]\\d{6}|7\\d{6,7}",[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7[3-8]"]]]],"TM":["993","[1-6]\\d{7}",[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"]],["(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["13|[2-5]"]]],"8","(8 $1)"],"TN":["216","[2-57-9]\\d{7}",[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3"]]],"TO":["676","[02-8]\\d{4,6}",[["(\\d{2})(\\d{3})","$1-$2",["[1-6]|7[0-4]|8[05]"]],["(\\d{3})(\\d{4})","$1 $2",["7[5-9]|8[47-9]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]]]],"TR":["90","[2-589]\\d{9}|444\\d{4}",[["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[23]|4(?:[0-35-9]|4[0-35-9])"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[02-69]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["51|[89]"],"0$1"],["(444)(\\d{1})(\\d{3})","$1 $2 $3",["444"]]],"0",null,null,null,true],"TT":["1","[589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"868"],"TV":["688","[279]\\d{4,6}"],"TW":["886","2\\d{6,8}|[3-689]\\d{7,8}|7\\d{7,9}",[["(20)(\\d)(\\d{4})","$1 $2 $3",["202"]],["([258]0)(\\d{3})(\\d{4})","$1 $2 $3",["20[013-9]|50[0-46-9]|80[0-79]"]],["([2-8])(\\d{3,4})(\\d{4})","$1 $2 $3",["[25][2-8]|[346]|[78][1-9]"]],["(9\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"]],["(70)(\\d{4})(\\d{4})","$1 $2 $3",["70"]]],"0","0$1"],"TZ":["255","\\d{9}",[["([24]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[24]"]],["([67]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"]],["([89]\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"]]],"0","0$1"],"UA":["380","[3-9]\\d{8}",[["([3-9]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[38]9|4(?:[45][0-5]|87)|5(?:0|[67][37])|6[36-8]|7|9[1-9]","[38]9|4(?:[45][0-5]|87)|5(?:0|6(?:3[14-7]|7)|7[37])|6[36-8]|7|9[1-9]"]],["([3-689]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["(?:3[1-8]|4[136-8])2|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|8[0-8]|90","3(?:[1-46-8]2[013-9]|52)|4(?:[1378]2|62[013-9])|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|8[0-8]|90"]],["([3-6]\\d{3})(\\d{5})","$1 $2",["3(?:[1-46-8]|5[013-9])|4(?:[137][013-9]|[45][6-9]|6|8[4-6])|5(?:[1245][013-9]|3|6[0135689]|7[4-6])|6(?:[12][13-8]|[49][013-9]|5[0135-9])","3(?:[1-46-8](?:[013-9]|22)|5[013-9])|4(?:[137][013-9]|[45][6-9]|6(?:[013-9]|22)|8[4-6])|5(?:[1245][013-9]|3|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][13-8]|[49][013-9]|5[0135-9])"]]],"0","0$1"],"UG":["256","\\d{9}",[["(\\d{3})(\\d{6})","$1 $2",["20[0-8]|4(?:6[45]|[7-9])|[7-9]","20(?:[013-8]|2[5-9])|4(?:6[45]|[7-9])|[7-9]"]],["(\\d{2})(\\d{7})","$1 $2",["3|4(?:[1-5]|6[0-36-9])"]],["(2024)(\\d{5})","$1 $2",["202","2024"]]],"0","0$1"],"US":["1","[2-9]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,true,null,["(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[026]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[16]|5[017]|6[0-279]|78|8[012])|7(?:0[1-46-8]|1[02-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|28|3[0-258]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[014678]|4[0179]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}",null,"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}","900[2-9]\\d{6}","5(?:00|22|33|44|66|77|88)[2-9]\\d{6}"]],"UY":["598","[2489]\\d{6,7}",[["(\\d{4})(\\d{4})","$1 $2",["[24]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9[1-9]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["[89]0"],"0$1"]],"0"],"UZ":["998","[679]\\d{8}",[["([679]\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[679]"]]],"8","8 $1"],"VA":["39","(?:0(?:878\\d{5}|6698\\d{5})|[1589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9}))",[["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|55"]],["(0[26])(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(0[26])(\\d{4,6})","$1 $2",["0[26]"]],["(0\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[245])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]],["(0\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["0[13-57-9][2-46-8]"]],["(0\\d{3})(\\d{2,6})","$1 $2",["0[13-57-9][2-46-8]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13]|8(?:00|4[08]|9[59])","[13]|8(?:00|4[08]|9(?:5[5-9]|9))"]],["(\\d{4})(\\d{4})","$1 $2",["894","894[5-9]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["3"]]],null,null,null,null,null,null,["06698\\d{5}","3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})","80(?:0\\d{6}|3\\d{3})","0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})","1(?:78\\d|99)\\d{6}",null,null,null,"55\\d{8}","84(?:[08]\\d{6}|[17]\\d{3})"]],"VC":["1","[5789]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"784"],"VE":["58","[24589]\\d{9}",[["(\\d{3})(\\d{7})","$1-$2"]],"0","0$1"],"VG":["1","[2589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"284"],"VI":["1","[3589]\\d{9}",[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",null,null,null,"$1-$2-$3"]],"1",null,null,null,null,"340"],"VN":["84","1\\d{6,9}|2\\d{9}|6\\d{6,7}|7\\d{6}|8\\d{6,8}|9\\d{8}",[["([17]99)(\\d{4})","$1 $2",["[17]99"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"]],["(80)(\\d{5})","$1 $2",["80"]],["(69\\d)(\\d{4,5})","$1 $2",["69"]],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2[0-35-79]"]],["([89]\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8(?:8|9[89])|9"]],["(1[2689]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1(?:[26]|8[68]|99)"]],["(86[89])(\\d{3})(\\d{3})","$1 $2 $3",["86[89]"]],["(1[89]00)(\\d{4,6})","$1 $2",["1[89]0","1[89]00"],"$1"]],"0","0$1",null,null,true],"VU":["678","[2-57-9]\\d{4,6}",[["(\\d{3})(\\d{4})","$1 $2",["[579]"]]]],"WF":["681","[4-8]\\d{5}",[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3"]]],"WS":["685","[2-8]\\d{4,6}",[["(8\\d{2})(\\d{3,4})","$1 $2",["8"]],["(7\\d)(\\d{5})","$1 $2",["7"]],["(\\d{5})","$1",["[2-6]"]]]],"YE":["967","[1-7]\\d{6,8}",[["([1-7])(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7[24-68]"]],["(7\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["7[0137]"]]],"0","0$1"],"YT":["262","[268]\\d{8}",[["([268]\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[268]"]]],"0",null,null,null,null,"269|63"],"ZA":["27","[1-79]\\d{8}|8\\d{4,8}",[["(860)(\\d{3})(\\d{3})","$1 $2 $3",["860"]],["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"]],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-79]|8(?:[0-57]|6[1-9])"]]],"0","0$1"],"ZM":["260","[289]\\d{8}",[["([29]\\d)(\\d{7})","$1 $2",["[29]"]],["(800)(\\d{3})(\\d{3})","$1 $2 $3",["800"]]],"0","0$1"],"ZW":["263","2(?:[0-57-9]\\d{3,8}|6(?:[14]\\d{7}|\\d{4}))|[13-79]\\d{4,9}|8[06]\\d{5,8}",[["([49])(\\d{3})(\\d{2,4})","$1 $2 $3",["4|9[2-9]"]],["(7\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["7"]],["(86\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["86[24]"]],["([2356]\\d{2})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8|[78])|3(?:[09]8|17|3[78]|7[1569]|8[37])|5[15][78]|6(?:[29]8|37|[68][78]|75)"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|31|[56][14]|7[35]|84)|329"]],["([1-356]\\d)(\\d{3,5})","$1 $2",["1[3-9]|2[02569]|3[0-69]|5[05689]|6"]],["([235]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[23]9|54"]],["([25]\\d{3})(\\d{3,5})","$1 $2",["(?:25|54)8","258[23]|5483"]],["(8\\d{3})(\\d{6})","$1 $2",["86"]],["(80\\d)(\\d{4})","$1 $2",["80"]]],"0","0$1"],"001":["979","\\d{9}",[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3"]]]}}

/***/ }),

/***/ 418:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VuePhoneInput__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_scss__);
/* eslint-disable */



/* eslint-enable */



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__VuePhoneInput__["a" /* default */]);

/* eslint-disable no-undef */

if (window && window.Vue) {
  window.Vue.component('vue-phone-input', __WEBPACK_IMPORTED_MODULE_0__VuePhoneInput__["a" /* default */]);
}

/* eslint-enable no-undef */

/***/ }),

/***/ 419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50a62072_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(424);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50a62072_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-unused-vars */

var has = Object.hasOwnProperty;
var isObject = function isObject(maybeObj) {
  return Object.prototype.toString.call(maybeObj) === '[object Object]';
};
var isArray = function isArray(maybeArray) {
  return Object.prototype.toString.call(maybeArray) === '[object Array]';
};
var isString = function isString(maybeString) {
  return Object.prototype.toString.call(maybeString) === '[object String]';
};
var isFunction = function isFunction(maybeFunc) {
  return Object.prototype.toString.call(maybeFunc) === '[object Function]';
};

/* eslint-disable object-curly-newline */

var phonesData = {
  af: { code: 'af', name: 'Afghanistan (‫افغانستان‬‎)', dialCode: 93, example: '070 123 4567' },
  al: { code: 'al', name: 'Albania (Shqipëri)', dialCode: 355, example: '066 123 4567' },
  dz: { code: 'dz', name: 'Algeria (‫الجزائر‬‎)', dialCode: 213, example: '0551 23 45 67' },
  as: { code: 'as', name: 'American Samoa', dialCode: 1684, example: '(684) 733-1234' },
  ad: { code: 'ad', name: 'Andorra', dialCode: 376, example: '312 345' },
  ao: { code: 'ao', name: 'Angola', dialCode: 244, example: '923 123 456' },
  ai: { code: 'ai', name: 'Anguilla', dialCode: 1264, example: '(264) 235-1234' },
  ag: { code: 'ag', name: 'Antigua and Barbuda', dialCode: 1268, example: '(268) 464-1234' },
  ar: { code: 'ar', name: 'Argentina', dialCode: 54, example: '011 15-2345-6789' },
  am: { code: 'am', name: 'Armenia (Հայաստան)', dialCode: 374, example: '077 123456' },
  aw: { code: 'aw', name: 'Aruba', dialCode: 297, example: '560 1234' },
  au: { code: 'au', name: 'Australia', dialCode: 61, example: '0412 345 678' },
  at: { code: 'at', name: 'Austria (Österreich)', dialCode: 43, example: '0664 123456' },
  az: { code: 'az', name: 'Azerbaijan (Azərbaycan)', dialCode: 994, example: '040 123 45 67' },
  bs: { code: 'bs', name: 'Bahamas', dialCode: 1242, example: '(242) 359-1234' },
  bh: { code: 'bh', name: 'Bahrain (‫البحرين‬‎)', dialCode: 973, example: '3600 1234' },
  bd: { code: 'bd', name: 'Bangladesh (বাংলাদেশ)', dialCode: 880, example: '01812-345678' },
  bb: { code: 'bb', name: 'Barbados', dialCode: 1246, example: '(246) 250-1234' },
  by: { code: 'by', name: 'Belarus (Беларусь)', dialCode: 375, example: '8 029 491-19-11' },
  be: { code: 'be', name: 'Belgium (België)', dialCode: 32, example: '0470 12 34 56' },
  bz: { code: 'bz', name: 'Belize', dialCode: 501, example: '622-1234' },
  bj: { code: 'bj', name: 'Benin (Bénin)', dialCode: 229, example: '90 01 12 34' },
  bm: { code: 'bm', name: 'Bermuda', dialCode: 1441, example: '(441) 370-1234' },
  bt: { code: 'bt', name: 'Bhutan (འབྲུག)', dialCode: 975, example: '17 12 34 56' },
  bo: { code: 'bo', name: 'Bolivia', dialCode: 591, example: '71234567' },
  ba: { code: 'ba', name: 'Bosnia and Herzegovina (Босна и Херцеговина)', dialCode: 387, example: '061 123 456' },
  bw: { code: 'bw', name: 'Botswana', dialCode: 267, example: '71 123 456' },
  br: { code: 'br', name: 'Brazil (Brasil)', dialCode: 55, example: '(11) 96123-4567' },
  io: { code: 'io', name: 'British Indian Ocean Territory', dialCode: 246, example: '380 1234' },
  vg: { code: 'vg', name: 'British Virgin Islands', dialCode: 1284, example: '(284) 300-1234' },
  bn: { code: 'bn', name: 'Brunei', dialCode: 673, example: '712 3456' },
  bg: { code: 'bg', name: 'Bulgaria (България)', dialCode: 359, example: '048 123 456' },
  bf: { code: 'bf', name: 'Burkina Faso', dialCode: 226, example: '70 12 34 56' },
  bi: { code: 'bi', name: 'Burundi (Uburundi)', dialCode: 257, example: '79 56 12 34' },
  kh: { code: 'kh', name: 'Cambodia (កម្ពុជា)', dialCode: 855, example: '091 234 567' },
  cm: { code: 'cm', name: 'Cameroon (Cameroun)', dialCode: 237, example: '6 71 23 45 67' },
  ca: { code: 'ca', name: 'Canada', dialCode: 1, example: '(204) 234-5678' },
  cv: { code: 'cv', name: 'Cape Verde (Kabu Verdi)', dialCode: 238, example: '991 12 34' },
  bq: { code: 'bq', name: 'Caribbean Netherlands', dialCode: 599, example: '318 1234' },
  ky: { code: 'ky', name: 'Cayman Islands', dialCode: 1345, example: '(345) 323-1234' },
  cf: { code: 'cf', name: 'Central African Republic (République centrafricaine)', dialCode: 236, example: '70 01 23 45' },
  td: { code: 'td', name: 'Chad (Tchad)', dialCode: 235, example: '63 01 23 45' },
  cl: { code: 'cl', name: 'Chile', dialCode: 56, example: '09 6123 4567' },
  cn: { code: 'cn', name: 'China (中国)', dialCode: 86, example: '131 2345 6789' },
  cx: { code: 'cx', name: 'Christmas Island', dialCode: 61, example: '0412 345 678' },
  cc: { code: 'cc', name: 'Cocos (Keeling) Islands', dialCode: 61, example: '0412 345 678' },
  co: { code: 'co', name: 'Colombia', dialCode: 57, example: '321 1234567' },
  km: { code: 'km', name: 'Comoros (‫جزر القمر‬‎)', dialCode: 269, example: '321 23 45' },
  cd: { code: 'cd', name: 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)', dialCode: 243, example: '0991 234 567' },
  cg: { code: 'cg', name: 'Congo (Republic) (Congo-Brazzaville)', dialCode: 242, example: '06 123 4567' },
  ck: { code: 'ck', name: 'Cook Islands', dialCode: 682, example: '71 234' },
  cr: { code: 'cr', name: 'Costa Rica', dialCode: 506, example: '8312 3456' },
  ci: { code: 'ci', name: 'Côte d’Ivoire', dialCode: 225, example: '01 23 45 67' },
  hr: { code: 'hr', name: 'Croatia (Hrvatska)', dialCode: 385, example: '091 234 5678' },
  cu: { code: 'cu', name: 'Cuba', dialCode: 53, example: '05 1234567' },
  cw: { code: 'cw', name: 'Curaçao', dialCode: 599, example: '9 518 1234' },
  cy: { code: 'cy', name: 'Cyprus (Κύπρος)', dialCode: 357, example: '96 123456' },
  cz: { code: 'cz', name: 'Czech Republic (Česká republika)', dialCode: 420, example: '601 123 456' },
  dk: { code: 'dk', name: 'Denmark (Danmark)', dialCode: 45, example: '20 12 34 56' },
  dj: { code: 'dj', name: 'Djibouti', dialCode: 253, example: '77 83 10 01' },
  dm: { code: 'dm', name: 'Dominica', dialCode: 1767, example: '(767) 225-1234' },
  do: { code: 'do', name: 'Dominican Republic (República Dominicana)', dialCode: 1, example: '(809) 234-5678' },
  ec: { code: 'ec', name: 'Ecuador', dialCode: 593, example: '099 123 4567' },
  eg: { code: 'eg', name: 'Egypt (‫مصر‬‎)', dialCode: 20, example: '0100 123 4567' },
  sv: { code: 'sv', name: 'El Salvador', dialCode: 503, example: '7012 3456' },
  gq: { code: 'gq', name: 'Equatorial Guinea (Guinea Ecuatorial)', dialCode: 240, example: '222 123 456' },
  er: { code: 'er', name: 'Eritrea', dialCode: 291, example: '07 123 456' },
  ee: { code: 'ee', name: 'Estonia (Eesti)', dialCode: 372, example: '5123 4567' },
  et: { code: 'et', name: 'Ethiopia', dialCode: 251, example: '091 123 4567' },
  fk: { code: 'fk', name: 'Falkland Islands (Islas Malvinas)', dialCode: 500, example: '51234' },
  fo: { code: 'fo', name: 'Faroe Islands (Føroyar)', dialCode: 298, example: '211234' },
  fj: { code: 'fj', name: 'Fiji', dialCode: 679, example: '701 2345' },
  fi: { code: 'fi', name: 'Finland (Suomi)', dialCode: 358, example: '041 2345678' },
  fr: { code: 'fr', name: 'France', dialCode: 33, example: '06 12 34 56 78' },
  gf: { code: 'gf', name: 'French Guiana (Guyane française)', dialCode: 594, example: '0694 20 12 34' },
  pf: { code: 'pf', name: 'French Polynesia (Polynésie française)', dialCode: 689, example: '87 12 34 56' },
  ga: { code: 'ga', name: 'Gabon', dialCode: 241, example: '06 03 12 34' },
  gm: { code: 'gm', name: 'Gambia', dialCode: 220, example: '301 2345' },
  ge: { code: 'ge', name: 'Georgia (საქართველო)', dialCode: 995, example: '555 12 34 56' },
  de: { code: 'de', name: 'Germany (Deutschland)', dialCode: 49, example: '01512 3456789' },
  gh: { code: 'gh', name: 'Ghana (Gaana)', dialCode: 233, example: '023 123 4567' },
  gi: { code: 'gi', name: 'Gibraltar', dialCode: 350, example: '57123456' },
  gr: { code: 'gr', name: 'Greece (Ελλάδα)', dialCode: 30, example: '691 234 5678' },
  gl: { code: 'gl', name: 'Greenland (Kalaallit Nunaat)', dialCode: 299, example: '22 12 34' },
  gd: { code: 'gd', name: 'Grenada', dialCode: 1473, example: '(473) 403-1234' },
  gp: { code: 'gp', name: 'Guadeloupe', dialCode: 590, example: '0690 30-1234' },
  gu: { code: 'gu', name: 'Guam', dialCode: 1671, example: '(671) 300-1234' },
  gt: { code: 'gt', name: 'Guatemala', dialCode: 502, example: '5123 4567' },
  gg: { code: 'gg', name: 'Guernsey', dialCode: 44, example: '07781 123456' },
  gn: { code: 'gn', name: 'Guinea (Guinée)', dialCode: 224, example: '601 12 34 56' },
  gw: { code: 'gw', name: 'Guinea-Bissau (Guiné Bissau)', dialCode: 245, example: '955 012 345' },
  gy: { code: 'gy', name: 'Guyana', dialCode: 592, example: '609 1234' },
  ht: { code: 'ht', name: 'Haiti', dialCode: 509, example: '34 10 1234' },
  hn: { code: 'hn', name: 'Honduras', dialCode: 504, example: '9123-4567' },
  hk: { code: 'hk', name: 'Hong Kong (香港)', dialCode: 852, example: '5123 4567' },
  hu: { code: 'hu', name: 'Hungary (Magyarország)', dialCode: 36, example: '(20) 123 4567' },
  is: { code: 'is', name: 'Iceland (Ísland)', dialCode: 354, example: '611 1234' },
  in: { code: 'in', name: 'India (भारत)', dialCode: 91, example: '099876 54321' },
  id: { code: 'id', name: 'Indonesia', dialCode: 62, example: '0812-345-678' },
  ir: { code: 'ir', name: 'Iran (‫ایران‬‎)', dialCode: 98, example: '0912 345 6789' },
  iq: { code: 'iq', name: 'Iraq (‫العراق‬‎)', dialCode: 964, example: '0791 234 5678' },
  ie: { code: 'ie', name: 'Ireland', dialCode: 353, example: '085 012 3456' },
  im: { code: 'im', name: 'Isle of Man', dialCode: 44, example: '07924 123456' },
  il: { code: 'il', name: 'Israel (‫ישראל‬‎)', dialCode: 972, example: '050-123-4567' },
  it: { code: 'it', name: 'Italy (Italia)', dialCode: 39, example: '312 345 6789' },
  jm: { code: 'jm', name: 'Jamaica', dialCode: 1876, example: '(876) 210-1234' },
  jp: { code: 'jp', name: 'Japan (日本)', dialCode: 81, example: '090-1234-5678' },
  je: { code: 'je', name: 'Jersey', dialCode: 44, example: '07797 123456' },
  jo: { code: 'jo', name: 'Jordan (‫الأردن‬‎)', dialCode: 962, example: '07 9012 3456' },
  kz: { code: 'kz', name: 'Kazakhstan (Казахстан)', dialCode: 7, example: '8 (771) 000 9998' },
  ke: { code: 'ke', name: 'Kenya', dialCode: 254, example: '0712 123456' },
  ki: { code: 'ki', name: 'Kiribati', dialCode: 686, example: '72012345' },
  xk: { code: 'xk', name: 'Kosovo', dialCode: 383, example: '' },
  kw: { code: 'kw', name: 'Kuwait (‫الكويت‬‎)', dialCode: 965, example: '500 12345' },
  kg: { code: 'kg', name: 'Kyrgyzstan (Кыргызстан)', dialCode: 996, example: '0700 123 456' },
  la: { code: 'la', name: 'Laos (ລາວ)', dialCode: 856, example: '020 23 123 456' },
  lv: { code: 'lv', name: 'Latvia (Latvija)', dialCode: 371, example: '21 234 567' },
  lb: { code: 'lb', name: 'Lebanon (‫لبنان‬‎)', dialCode: 961, example: '71 123 456' },
  ls: { code: 'ls', name: 'Lesotho', dialCode: 266, example: '5012 3456' },
  lr: { code: 'lr', name: 'Liberia', dialCode: 231, example: '077 012 3456' },
  ly: { code: 'ly', name: 'Libya (‫ليبيا‬‎)', dialCode: 218, example: '091-2345678' },
  li: { code: 'li', name: 'Liechtenstein', dialCode: 423, example: '660 234 567' },
  lt: { code: 'lt', name: 'Lithuania (Lietuva)', dialCode: 370, example: '(8-612) 34567' },
  lu: { code: 'lu', name: 'Luxembourg', dialCode: 352, example: '628 123 456' },
  mo: { code: 'mo', name: 'Macau (澳門)', dialCode: 853, example: '6612 3456' },
  mk: { code: 'mk', name: 'Macedonia (FYROM) (Македонија)', dialCode: 389, example: '072 345 678' },
  mg: { code: 'mg', name: 'Madagascar (Madagasikara)', dialCode: 261, example: '032 12 345 67' },
  mw: { code: 'mw', name: 'Malawi', dialCode: 265, example: '0991 23 45 67' },
  my: { code: 'my', name: 'Malaysia', dialCode: 60, example: '012-345 6789' },
  mv: { code: 'mv', name: 'Maldives', dialCode: 960, example: '771-2345' },
  ml: { code: 'ml', name: 'Mali', dialCode: 223, example: '65 01 23 45' },
  mt: { code: 'mt', name: 'Malta', dialCode: 356, example: '9696 1234' },
  mh: { code: 'mh', name: 'Marshall Islands', dialCode: 692, example: '235-1234' },
  mq: { code: 'mq', name: 'Martinique', dialCode: 596, example: '0696 20 12 34' },
  mr: { code: 'mr', name: 'Mauritania (‫موريتانيا‬‎)', dialCode: 222, example: '22 12 34 56' },
  mu: { code: 'mu', name: 'Mauritius (Moris)', dialCode: 230, example: '5251 2345' },
  yt: { code: 'yt', name: 'Mayotte', dialCode: 262, example: '0639 12 34 56' },
  mx: { code: 'mx', name: 'Mexico (México)', dialCode: 52, example: '044 222 123 4567' },
  fm: { code: 'fm', name: 'Micronesia', dialCode: 691, example: '350 1234' },
  md: { code: 'md', name: 'Moldova (Republica Moldova)', dialCode: 373, example: '0621 12 345' },
  mc: { code: 'mc', name: 'Monaco', dialCode: 377, example: '06 12 34 56 78' },
  mn: { code: 'mn', name: 'Mongolia (Монгол)', dialCode: 976, example: '8812 3456' },
  me: { code: 'me', name: 'Montenegro (Crna Gora)', dialCode: 382, example: '067 622 901' },
  ms: { code: 'ms', name: 'Montserrat', dialCode: 1664, example: '(664) 492-3456' },
  ma: { code: 'ma', name: 'Morocco (‫المغرب‬‎)', dialCode: 212, example: '0650-123456' },
  mz: { code: 'mz', name: 'Mozambique (Moçambique)', dialCode: 258, example: '82 123 4567' },
  mm: { code: 'mm', name: 'Myanmar (Burma) (မြန်မာ)', dialCode: 95, example: '09 212 3456' },
  na: { code: 'na', name: 'Namibia (Namibië)', dialCode: 264, example: '081 123 4567' },
  nr: { code: 'nr', name: 'Nauru', dialCode: 674, example: '555 1234' },
  np: { code: 'np', name: 'Nepal (नेपाल)', dialCode: 977, example: '984-1234567' },
  nl: { code: 'nl', name: 'Netherlands (Nederland)', dialCode: 31, example: '06 12345678' },
  nc: { code: 'nc', name: 'New Caledonia (Nouvelle-Calédonie)', dialCode: 687, example: '75.12.34' },
  nz: { code: 'nz', name: 'New Zealand', dialCode: 64, example: '021 123 4567' },
  ni: { code: 'ni', name: 'Nicaragua', dialCode: 505, example: '8123 4567' },
  ne: { code: 'ne', name: 'Niger (Nijar)', dialCode: 227, example: '93 12 34 56' },
  ng: { code: 'ng', name: 'Nigeria', dialCode: 234, example: '0802 123 4567' },
  nu: { code: 'nu', name: 'Niue', dialCode: 683, example: '1234' },
  nf: { code: 'nf', name: 'Norfolk Island', dialCode: 672, example: '3 81234' },
  kp: { code: 'kp', name: 'North Korea (조선 민주주의 인민 공화국)', dialCode: 850, example: '0192 123 4567' },
  mp: { code: 'mp', name: 'Northern Mariana Islands', dialCode: 1670, example: '(670) 234-5678' },
  no: { code: 'no', name: 'Norway (Norge)', dialCode: 47, example: '406 12 345' },
  om: { code: 'om', name: 'Oman (‫عُمان‬‎)', dialCode: 968, example: '9212 3456' },
  pk: { code: 'pk', name: 'Pakistan (‫پاکستان‬‎)', dialCode: 92, example: '0301 2345678' },
  pw: { code: 'pw', name: 'Palau', dialCode: 680, example: '620 1234' },
  ps: { code: 'ps', name: 'Palestine (‫فلسطين‬‎)', dialCode: 970, example: '0599 123 456' },
  pa: { code: 'pa', name: 'Panama (Panamá)', dialCode: 507, example: '6001-2345' },
  pg: { code: 'pg', name: 'Papua New Guinea', dialCode: 675, example: '681 2345' },
  py: { code: 'py', name: 'Paraguay', dialCode: 595, example: '0961 456789' },
  pe: { code: 'pe', name: 'Peru (Perú)', dialCode: 51, example: '912 345 678' },
  ph: { code: 'ph', name: 'Philippines', dialCode: 63, example: '0905 123 4567' },
  pl: { code: 'pl', name: 'Poland (Polska)', dialCode: 48, example: '512 345 678' },
  pt: { code: 'pt', name: 'Portugal', dialCode: 351, example: '912 345 678' },
  pr: { code: 'pr', name: 'Puerto Rico', dialCode: 1, example: '(787) 234-5678' },
  qa: { code: 'qa', name: 'Qatar (‫قطر‬‎)', dialCode: 974, example: '3312 3456' },
  re: { code: 're', name: 'Réunion (La Réunion)', dialCode: 262, example: '0692 12 34 56' },
  ro: { code: 'ro', name: 'Romania (România)', dialCode: 40, example: '0712 345 678' },
  ru: { code: 'ru', name: 'Russia (Россия)', dialCode: 7, example: '8 (912) 345-67-89' },
  rw: { code: 'rw', name: 'Rwanda', dialCode: 250, example: '0720 123 456' },
  bl: { code: 'bl', name: 'Saint Barthélemy (Saint-Barthélemy)', dialCode: 590, example: '0690 30-1234' },
  sh: { code: 'sh', name: 'Saint Helena', dialCode: 290, example: '51234' },
  kn: { code: 'kn', name: 'Saint Kitts and Nevis', dialCode: 1869, example: '(869) 765-2917' },
  lc: { code: 'lc', name: 'Saint Lucia', dialCode: 1758, example: '(758) 284-5678' },
  mf: { code: 'mf', name: 'Saint Martin (Saint-Martin (partie française))', dialCode: 590, example: '0690 30-1234' },
  pm: { code: 'pm', name: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)', dialCode: 508, example: '055 12 34' },
  vc: { code: 'vc', name: 'Saint Vincent and the Grenadines', dialCode: 1784, example: '(784) 430-1234' },
  ws: { code: 'ws', name: 'Samoa', dialCode: 685, example: '601234' },
  sm: { code: 'sm', name: 'San Marino', dialCode: 378, example: '66 66 12 12' },
  st: { code: 'st', name: 'São Tomé and Príncipe (São Tomé e Príncipe)', dialCode: 239, example: '981 2345' },
  sa: { code: 'sa', name: 'Saudi Arabia (‫المملكة العربية السعودية‬‎)', dialCode: 966, example: '051 234 5678' },
  sn: { code: 'sn', name: 'Senegal (Sénégal)', dialCode: 221, example: '70 123 45 67' },
  rs: { code: 'rs', name: 'Serbia (Србија)', dialCode: 381, example: '060 1234567' },
  sc: { code: 'sc', name: 'Seychelles', dialCode: 248, example: '2 510 123' },
  sl: { code: 'sl', name: 'Sierra Leone', dialCode: 232, example: '(025) 123456' },
  sg: { code: 'sg', name: 'Singapore', dialCode: 65, example: '8123 4567' },
  sx: { code: 'sx', name: 'Sint Maarten', dialCode: 1721, example: '(721) 520-5678' },
  sk: { code: 'sk', name: 'Slovakia (Slovensko)', dialCode: 421, example: '0912 123 456' },
  si: { code: 'si', name: 'Slovenia (Slovenija)', dialCode: 386, example: '031 234 567' },
  sb: { code: 'sb', name: 'Solomon Islands', dialCode: 677, example: '74 21234' },
  so: { code: 'so', name: 'Somalia (Soomaaliya)', dialCode: 252, example: '7 1123456' },
  za: { code: 'za', name: 'South Africa', dialCode: 27, example: '071 123 4567' },
  kr: { code: 'kr', name: 'South Korea (대한민국)', dialCode: 82, example: '010-0000-0000' },
  ss: { code: 'ss', name: 'South Sudan (‫جنوب السودان‬‎)', dialCode: 211, example: '0977 123 456' },
  es: { code: 'es', name: 'Spain (España)', dialCode: 34, example: '612 34 56 78' },
  lk: { code: 'lk', name: 'Sri Lanka (ශ්‍රී ලංකාව)', dialCode: 94, example: '071 234 5678' },
  sd: { code: 'sd', name: 'Sudan (‫السودان‬‎)', dialCode: 249, example: '091 123 1234' },
  sr: { code: 'sr', name: 'Suriname', dialCode: 597, example: '741-2345' },
  sj: { code: 'sj', name: 'Svalbard and Jan Mayen', dialCode: 47, example: '412 34 567' },
  sz: { code: 'sz', name: 'Swaziland', dialCode: 268, example: '7612 3456' },
  se: { code: 'se', name: 'Sweden (Sverige)', dialCode: 46, example: '070-123 45 67' },
  ch: { code: 'ch', name: 'Switzerland (Schweiz)', dialCode: 41, example: '078 123 45 67' },
  sy: { code: 'sy', name: 'Syria (‫سوريا‬‎)', dialCode: 963, example: '0944 567 890' },
  tw: { code: 'tw', name: 'Taiwan (台灣)', dialCode: 886, example: '0912 345 678' },
  tj: { code: 'tj', name: 'Tajikistan', dialCode: 992, example: '(8) 917 12 3456' },
  tz: { code: 'tz', name: 'Tanzania', dialCode: 255, example: '0621 234 567' },
  th: { code: 'th', name: 'Thailand (ไทย)', dialCode: 66, example: '081 234 5678' },
  tl: { code: 'tl', name: 'Timor-Leste', dialCode: 670, example: '7721 2345' },
  tg: { code: 'tg', name: 'Togo', dialCode: 228, example: '90 11 23 45' },
  tk: { code: 'tk', name: 'Tokelau', dialCode: 690, example: '7290' },
  to: { code: 'to', name: 'Tonga', dialCode: 676, example: '771 5123' },
  tt: { code: 'tt', name: 'Trinidad and Tobago', dialCode: 1868, example: '(868) 291-1234' },
  tn: { code: 'tn', name: 'Tunisia (‫تونس‬‎)', dialCode: 216, example: '20 123 456' },
  tr: { code: 'tr', name: 'Turkey (Türkiye)', dialCode: 90, example: '0501 234 56 78' },
  tm: { code: 'tm', name: 'Turkmenistan', dialCode: 993, example: '8 66 123456' },
  tc: { code: 'tc', name: 'Turks and Caicos Islands', dialCode: 1649, example: '(649) 231-1234' },
  tv: { code: 'tv', name: 'Tuvalu', dialCode: 688, example: '901234' },
  us: { code: 'us', name: 'United States', dialCode: 1, example: '(201) 555-0123' },
  gb: { code: 'gb', name: 'United Kingdom', dialCode: 44, example: '07400 123456' },
  vi: { code: 'vi', name: 'U.S. Virgin Islands', dialCode: 1340, example: '(340) 642-1234' },
  ug: { code: 'ug', name: 'Uganda', dialCode: 256, example: '0712 345678' },
  ua: { code: 'ua', name: 'Ukraine (Україна)', dialCode: 380, example: '039 123 4567' },
  ae: { code: 'ae', name: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)', dialCode: 971, example: '050 123 4567' },
  uy: { code: 'uy', name: 'Uruguay', dialCode: 598, example: '094 231 234' },
  uz: { code: 'uz', name: 'Uzbekistan (Oʻzbekiston)', dialCode: 998, example: '8 91 234 56 78' },
  vu: { code: 'vu', name: 'Vanuatu', dialCode: 678, example: '591 2345' },
  va: { code: 'va', name: 'Vatican City (Città del Vaticano)', dialCode: 39, example: '312 345 6789' },
  ve: { code: 've', name: 'Venezuela', dialCode: 58, example: '0412-1234567' },
  vn: { code: 'vn', name: 'Vietnam (Việt Nam)', dialCode: 84, example: '091 234 56 78' },
  wf: { code: 'wf', name: 'Wallis and Futuna', dialCode: 681, example: '50 12 34' },
  eh: { code: 'eh', name: 'Western Sahara (‫الصحراء الغربية‬‎)', dialCode: 212, example: '0650-123456' },
  ye: { code: 'ye', name: 'Yemen (‫اليمن‬‎)', dialCode: 967, example: '0712 345 678' },
  zm: { code: 'zm', name: 'Zambia', dialCode: 260, example: '095 5123456' },
  zw: { code: 'zw', name: 'Zimbabwe', dialCode: 263, example: '071 123 4567' },
  ax: { code: 'ax', name: 'Åland Islands', dialCode: 358, example: '041 2345678' }
};

/* eslint-enable object-curly-newline, no-unused-vars */

var counter = 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    disabled: {
      default: false
    },
    name: {
      type: String,
      default: function _default() {
        counter += 1;
        return 'tel-input-' + counter;
      }
    },
    value: {
      type: [Number, String],
      default: ''
    },
    availbleOnly: {
      type: Array,
      default: null
    },
    toFront: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    code: {
      type: String,
      default: null
    },
    onChange: {
      type: Function,
      default: null
    },
    onInit: {
      type: Function,
      default: null
    }
  },

  data: function data() {
    var code = this.code,
        availableOnly = this.availableOnly,
        value = this.value;

    var tmpPhonesData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, phonesData);

    if (isArray(availableOnly)) {
      tmpPhonesData = {};
      availableOnly.forEach(function (item) {
        if (has.call(phonesData, item)) {
          tmpPhonesData[item] = phonesData[item];
        }
      });
    }

    this.availableData = tmpPhonesData;
    var needCode = has.call(this.availableData, code) ? code : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.availableData)[0];

    if (!needCode) {
      throw new Error('Available data is empty.Please set correct "availableOnly" attribute [vue-phone-input]');
    }

    return {
      phoneNumber: value,
      countryCode: needCode,
      isVisiblePanel: false
    };
  },


  computed: {
    intlData: function intlData() {
      return this.availableData[this.countryCode];
    },
    itemsData: function itemsData() {
      var frontItems = [];
      var otherItems = [];
      var phonesDataCopy = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.availableData);

      this.toFront.forEach(function (code) {
        var item = phonesDataCopy[code];

        if (isObject(item)) {
          frontItems.push(item);
          delete phonesDataCopy[code];
        }
      });

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(phonesDataCopy).forEach(function (item) {
        return otherItems.push(item);
      });
      var needSeparator = frontItems.length > 0 && otherItems.length > 0;

      return {
        frontItems: frontItems,
        otherItems: otherItems,
        needSeparator: needSeparator
      };
    },
    phoneDataObject: function phoneDataObject() {
      var dialCode = phonesData[this.countryCode].dialCode;
      return {
        dialCode: dialCode,
        phone: this.phoneNumber,
        country: this.countryCode,
        value: '+' + dialCode + this.phoneNumber
      };
    }
  },

  methods: {
    handleChangePhoneNumber: function handleChangePhoneNumber(event) {
      var phoneNumber = event.target.value;
      if (phoneNumber === this.phoneNumber) return;

      this.phoneNumber = phoneNumber;
      if (isFunction(this.onChange)) {
        this.onChange(this.phoneDataObject);
      }
    },
    setCode: function setCode(code) {
      this.hideList();
      if (this.countryCode === code) return;

      this.countryCode = code;
      if (isFunction(this.onChange)) {
        this.onChange(this.phoneDataObject);
      }
    },
    showList: function showList() {
      if (this.disabled) return;
      this.isVisiblePanel = true;
    },
    hideList: function hideList() {
      this.isVisiblePanel = false;
    },
    toggeList: function toggeList() {
      (this.isVisiblePanel ? this.hideList : this.showList)();
    }
  },

  mounted: function mounted() {
    if (isFunction(this.onInit)) {
      this.onInit(this);
    }
  }
});

/***/ }),

/***/ 424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intl-phone-input allow-dropdown",on:{"mouseleave":_vm.hideList}},[_c('div',{staticClass:"flag-container",on:{"click":function($event){$event.stopPropagation();_vm.toggeList($event)}}},[_c('div',{staticClass:"selected-flag"},[_c('div',{class:("iti-flag " + _vm.countryCode)}),_vm._v(" "),_c('div',{class:("iti-arrow" + (_vm.isVisiblePanel ? ' up' : ''))})]),_vm._v(" "),(_vm.isVisiblePanel)?_c('ul',{staticClass:"country-list"},[_vm._l((_vm.itemsData.frontItems),function(item){return _c('li',{class:("country" + (item.code === _vm.countryCode ? ' highlight' : '')),on:{"click":function($event){$event.stopPropagation();_vm.setCode(item.code)}}},[_c('div',{staticClass:"flag-box"},[_c('div',{class:("iti-flag " + (item.code))})]),_vm._v(" "),_c('span',{staticClass:"country-name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticClass:"dial-code"},[_vm._v("+"+_vm._s(item.dialCode))])])}),_vm._v(" "),(_vm.itemsData.needSeparator)?_c('li',{staticClass:"divider"}):_vm._e(),_vm._v(" "),_vm._l((_vm.itemsData.otherItems),function(item){return _c('li',{class:("country" + (item.code === _vm.countryCode ? ' highlight' : '')),on:{"click":function($event){$event.stopPropagation();_vm.setCode(item.code)}}},[_c('div',{staticClass:"flag-box"},[_c('div',{class:("iti-flag " + (item.code))})]),_vm._v(" "),_c('span',{staticClass:"country-name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticClass:"dial-code"},[_vm._v("+"+_vm._s(item.dialCode))])])})],2):_vm._e()]),_vm._v(" "),_c('input',{attrs:{"type":"number","autocomplete":"off","name":_vm.name,"placeholder":_vm.intlData.example,"disabled":_vm.disabled},domProps:{"value":_vm.phoneNumber},on:{"input":_vm.handleChangePhoneNumber}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuePhoneInput',{ref:"vuePhoneInput",staticClass:"vue-phone-input-wrapper",class:_vm.disabled ? 'disabled' : '',attrs:{"code":_vm.parsedNumber.country,"value":_vm.parsedNumber.phone,"onChange":_vm.change,"disabled":_vm.disabled}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_dialog__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dropdown_menu__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dropdown_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dropdown_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_item__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_menu__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_submenu__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_submenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_submenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu_item__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_menu_item_group__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_menu_item_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_menu_item_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input_number__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input_number__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_radio__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_radio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_radio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_radio_group__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_radio_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_radio_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_radio_button__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_radio_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_radio_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_checkbox__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_checkbox_group__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_checkbox_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_checkbox_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_select__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_option__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_option_group__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_option_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_option_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_button__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_button_group__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_button_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_button_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_popover__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_popover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_popover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_tooltip__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_form__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_form_item__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_form_item___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_form_item__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_tabs__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_tab_pane__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_tab_pane___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_tab_pane__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_element_ui_lib_tag__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_element_ui_lib_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_element_ui_lib_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_element_ui_lib_alert__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_element_ui_lib_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_element_ui_lib_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_element_ui_lib_icon__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_element_ui_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_element_ui_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_element_ui_lib_row__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_element_ui_lib_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_element_ui_lib_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_element_ui_lib_col__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_element_ui_lib_col___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_element_ui_lib_col__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_element_ui_lib_progress__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_element_ui_lib_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_element_ui_lib_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_element_ui_lib_card__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_element_ui_lib_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_element_ui_lib_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_element_ui_lib_steps__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_element_ui_lib_steps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_element_ui_lib_steps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_element_ui_lib_step__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_element_ui_lib_step___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_element_ui_lib_step__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_element_ui_lib_container__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_element_ui_lib_container___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_element_ui_lib_container__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_element_ui_lib_header__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_element_ui_lib_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_element_ui_lib_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_element_ui_lib_aside__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_element_ui_lib_aside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_element_ui_lib_aside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_element_ui_lib_main__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_element_ui_lib_main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_element_ui_lib_main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_element_ui_lib_footer__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_element_ui_lib_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_element_ui_lib_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_element_ui_lib_loading__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_element_ui_lib_message_box__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_element_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_element_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_element_ui_lib_message__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_element_ui_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_element_ui_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_element_ui_lib_notification__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_element_ui_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_element_ui_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_element_ui_lib_locale_lang_en__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_element_ui_lib_locale__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_element_ui_lib_locale__);


// import Pagination from 'element-ui/lib/pagination';

// import Autocomplete from 'element-ui/lib/autocomplete';













// import CheckboxButton from 'element-ui/lib/checkbox-button';

// import Switch from 'element-ui/lib/switch';





// import Table from 'element-ui/lib/table';
// import TableColumn from 'element-ui/lib/table-column';
// import DatePicker from 'element-ui/lib/date-picker';
// import TimeSelect from 'element-ui/lib/time-select';
// import TimePicker from 'element-ui/lib/time-picker';


// import Breadcrumb from 'element-ui/lib/breadcrumb';
// import BreadcrumbItem from 'element-ui/lib/breadcrumb-item';





// import Tree from 'element-ui/lib/tree';

// import Slider from 'element-ui/lib/slider';



// import Upload from 'element-ui/lib/upload';

// import Badge from 'element-ui/lib/badge';

// import Rate from 'element-ui/lib/rate';


// import Carousel from 'element-ui/lib/carousel';
// import CarouselItem from 'element-ui/lib/carousel-item';
// import Collapse from 'element-ui/lib/collapse';
// import CollapseItem from 'element-ui/lib/collapse-item';
// import Cascader from 'element-ui/lib/cascader';
// import ColorPicker from 'element-ui/lib/color-picker';










// Set up the locale of element-ui



__WEBPACK_IMPORTED_MODULE_46_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_45_element_ui_lib_locale_lang_en___default.a);

// Vue.use(Pagination);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_dialog___default.a);
// Vue.use(Autocomplete);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_dropdown___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_dropdown_menu___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_dropdown_item___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_menu___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_submenu___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_menu_item___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_menu_item_group___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_input_number___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_radio___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_radio_group___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_radio_button___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_checkbox___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_checkbox_group___default.a);
// Vue.use(Switch);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_option_group___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_button_group___default.a);
// Vue.use(Table);
// Vue.use(TableColumn);
// Vue.use(DatePicker);
// Vue.use(TimeSelect);
// Vue.use(TimePicker);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_popover___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_tooltip___default.a);
// Vue.use(Breadcrumb);
// Vue.use(BreadcrumbItem);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_form___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_form_item___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_tabs___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_tab_pane___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_27_element_ui_lib_tag___default.a);
// Vue.use(Tree);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_28_element_ui_lib_alert___default.a);
// Vue.use(Slider);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_29_element_ui_lib_icon___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_30_element_ui_lib_row___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_31_element_ui_lib_col___default.a);
// Vue.use(Upload);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_32_element_ui_lib_progress___default.a);
// Vue.use(Badge);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_33_element_ui_lib_card___default.a);
// Vue.use(Rate);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_34_element_ui_lib_steps___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_35_element_ui_lib_step___default.a);
// Vue.use(Carousel);
// Vue.use(CarouselItem);
// Vue.use(Collapse);
// Vue.use(CollapseItem);
// Vue.use(Cascader);
// Vue.use(ColorPicker);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_36_element_ui_lib_container___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_37_element_ui_lib_header___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_38_element_ui_lib_aside___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_element_ui_lib_main___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_40_element_ui_lib_footer___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$loading = __WEBPACK_IMPORTED_MODULE_41_element_ui_lib_loading___default.a.service;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$msgbox = __WEBPACK_IMPORTED_MODULE_42_element_ui_lib_message_box___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$alert = __WEBPACK_IMPORTED_MODULE_42_element_ui_lib_message_box___default.a.alert;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$confirm = __WEBPACK_IMPORTED_MODULE_42_element_ui_lib_message_box___default.a.confirm;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$prompt = __WEBPACK_IMPORTED_MODULE_42_element_ui_lib_message_box___default.a.prompt;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$notify = __WEBPACK_IMPORTED_MODULE_44_element_ui_lib_notification___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$message = __WEBPACK_IMPORTED_MODULE_43_element_ui_lib_message___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_41_element_ui_lib_loading___default.a.directive);

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_account__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_agreement__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_submission__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_submissionProgress__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_uploadQueue__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_dialogue__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_layout__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_networkActivity__ = __webpack_require__(198);


// Vuex modules
// Data model stores





// Service stores




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {},
  modules: {
    account: __WEBPACK_IMPORTED_MODULE_2__modules_account__["a" /* default */],
    agreement: __WEBPACK_IMPORTED_MODULE_3__modules_agreement__["a" /* default */],
    submission: __WEBPACK_IMPORTED_MODULE_4__modules_submission__["a" /* default */],
    submissionProgress: __WEBPACK_IMPORTED_MODULE_5__modules_submissionProgress__["a" /* default */],
    uploadQueue: __WEBPACK_IMPORTED_MODULE_6__modules_uploadQueue__["a" /* default */],

    dialogue: __WEBPACK_IMPORTED_MODULE_7__modules_dialogue__["a" /* default */],
    layout: __WEBPACK_IMPORTED_MODULE_8__modules_layout__["a" /* default */],
    networkActivity: __WEBPACK_IMPORTED_MODULE_9__modules_networkActivity__["a" /* default */]
  },
  strict: "production" !== 'production'
}));

/***/ }),

/***/ 496:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticStyle:{"min-height":"100vh"}},[_c('el-aside',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout.aside),expression:"layout.aside"}],class:_vm.layout.navCollapsed ? 'collapsed' : 'expanded'},[_c('vs-aside')],1),_vm._v(" "),_c('el-container',{staticStyle:{"width":"0"}},[_c('el-header',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout.header),expression:"layout.header"}],staticClass:"navigation"},[_c('vs-navigation')],1),_vm._v(" "),_c('el-main',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.isAccountReady),expression:"!isAccountReady"}]},[(_vm.isAccountReady)?_c('router-view'):_vm._e()],1)],1),_vm._v(" "),_c('SupportDialogue')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_navGuard__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Dashboard__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Submission__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Profile_Signup__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PageNotFound__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_routes_faq__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(44);


/* global ga */












var Login = function Login() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 526));
};
var Profile = function Profile() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 527));
};
var FastTrack = function FastTrack() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 528));
};
var SeriesFastTrack = function SeriesFastTrack() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 529));
};
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  // mode: 'history',
  routes: [{
    path: '/',
    redirect: { name: 'Dashboard' }
  }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__components_Dashboard__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__components_Submission__["a" /* default */]), [{ path: '/profile',
    name: 'Profile',
    component: Profile
  }, {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      fullscreen: true
    }
  }], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__components_Profile_Signup__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_8__router_routes_faq__["a" /* default */]), [{
    path: '/film-license',
    name: 'FastTrack',
    component: FastTrack,
    meta: {
      guest: true,
      fullscreen: true
    }
  }, {
    path: '/series-license',
    name: 'SeriesFastTrack',
    component: SeriesFastTrack
  }, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_7__components_PageNotFound__["a" /* default */],
    meta: {
      guest: true,
      fullscreen: true
    }
  }])
});

var handleFullscreen = function handleFullscreen(to, incomingRoute) {
  if (to.meta.fullscreen) {
    __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('layout/update', {
      aside: false,
      header: false,
      main: true,
      footer: false
    });
  } else {
    __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].commit('layout/update', {
      aside: true,
      header: true,
      main: true,
      footer: true
    });
  }
};

router.beforeEach(function (to, from, next) {
  var windowPathName = window.location.pathname;
  if (windowPathName !== '/' && typeof history !== 'undefined') {
    history.replaceState(null, '', '/#/');
    next(windowPathName);
    return;
  }

  if (to.path) {
    ga('set', 'page', to.path);
    ga('send', 'pageview');
  }

  if (!navigator.onLine && from.fullPath !== '/') {
    // TODO: Ajax request also need this functionality. Consider making this
    //       offline notifier as a module
    // Note: $notify module should have already been loaded at this point
    if (__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$notify) {
      __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$notify.warning({
        title: 'Warning',
        message: 'There is no Internet connection'
      });
    } else {
      // Fallback to alert in unexpected circumstances
      /* eslint no-alert: 0 */
      alert('Warning, there is no Internet connection');
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_navGuard__["a" /* default */])(to, function (incomingRoute) {
    if (incomingRoute === undefined) {
      handleFullscreen(to);
    }
    next(incomingRoute);
  });
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Dashboard = function Dashboard() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 516));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/dashboard',
  name: 'Dashboard',
  component: Dashboard
}]);

/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__children__ = __webpack_require__(201);
/**
 * This module defines the sub-routing for Submission component.
 * This module will be included and used inside the Router object.
 */

// Entry point to Submission component


var Submission = function Submission() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 521));
};

var STEP_PATH_NAME = '';

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/submission/',
  component: Submission
}, {
  path: '/submission/:videoId',
  redirect: '/submission/:videoId/' + STEP_PATH_NAME + 1,
  component: Submission,
  children: __WEBPACK_IMPORTED_MODULE_0__children__["a" /* default */].map(function (step, index) {
    return {
      path: '' + STEP_PATH_NAME + (index + 1),
      component: step.component
    };
  })
}]);

/***/ }),

/***/ 502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This module defines the sub-routing for Submission component.
 * This module will be included and used inside the Router object.
 */

// Entry point to Submission component

var FilmLicenseAgreement = function FilmLicenseAgreement() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 522));
};
var SignupFilmmaker = function SignupFilmmaker() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 523));
};
var SignupEmail = function SignupEmail() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 524));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/signup/',
  component: SignupFilmmaker,
  meta: {
    fullscreen: true
  }
}, {
  path: '/signup/agreement/',
  component: FilmLicenseAgreement,
  meta: {
    fullscreen: true
  }
}, {
  path: '/signup/email/',
  component: SignupEmail,
  meta: {
    fullscreen: true
  }
}]);

/***/ }),

/***/ 507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecb0bf40_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__ = __webpack_require__(508);
var normalizeComponent = __webpack_require__(7)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecb0bf40_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("404 - page not found")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 509:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This module defines the sub-routing for FAQ components.
 * This module will be included and used inside the Router object.
 */

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/faq/licensing',
  component: function component() {
    return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 525));
  },
  meta: {
    guest: true,
    fullscreen: true
  }
}]);

/***/ }),

/***/ 510:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Initialise services by importing
// import intercom from './intercom';



/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);



var _STATE_VARIABLE;

var STATE = {
  LIVE: 'creator.viddsee.com',
  STAGING: 'blueberry.viddsee.com',
  TEST: 'strawberry.viddsee.com',
  LOCAL: 'localhost'
};

var STATE_VARIABLE = (_STATE_VARIABLE = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_STATE_VARIABLE, STATE.LIVE, {
  BASE_URL: 'https://www.viddsee.com',
  API_URL: 'https://www.viddsee.com/v1/',
  AWS_FOLDER: 'submissions'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_STATE_VARIABLE, STATE.STAGING, {
  BASE_URL: 'http://blueberry.viddsee.com',
  API_URL: 'http://blueberry.viddsee.com/v1/',
  AWS_FOLDER: 'submissions'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_STATE_VARIABLE, STATE.TEST, {
  BASE_URL: 'https://strawberry.viddsee.com',
  API_URL: 'https://strawberry.viddsee.com/v1/',
  AWS_FOLDER: 'dev_submissions'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_STATE_VARIABLE, STATE.LOCAL, {
  BASE_URL: 'http://localhost:3000',
  API_URL: 'https://strawberry.viddsee.com/v1/',
  AWS_FOLDER: 'dev_submissions'
}), _STATE_VARIABLE);

// Set Application Current State if its host matches the given STATE,
// otherwise, set it to Test State
var currentState = STATE_VARIABLE[window.location.hostname] ? window.location.hostname : STATE.TEST;

var AWS = {
  UPLOAD_ENDPOINT: 'https://viddsee.s3.amazonaws.com',
  KEY: 'AKIAIZM3RQRE5XANYRAA',
  BUCKET: 'viddsee',
  SIGNER_URL: STATE_VARIABLE[currentState].API_URL + '/submitvideo/upload_signature',
  UPLOAD_FOLDER: STATE_VARIABLE[currentState].AWS_FOLDER
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, STATE_VARIABLE[currentState], {
  AWS: AWS,
  Survey: {
    ENDPOINT: 'https://0soms4dmv9.execute-api.ap-southeast-1.amazonaws.com/prod/survey'
  }
}));

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Store constants of submission status's type, color and label
 */
var TYPE = {
  moreinfo: 0,
  incomplete: 1,
  fasttrack: 2,
  pending: 3,
  approved: 4,
  rejected: 5
};

var INFO = [];
INFO[TYPE.moreinfo] = { color: '#D84078', label: 'Needs more information' };
INFO[TYPE.incomplete] = { color: '#D84078', label: 'Incomplete' };
INFO[TYPE.fasttrack] = { color: '#0085d8', label: 'License Submitted' };
INFO[TYPE.pending] = { color: '#f0ad4e', label: 'Under Review' };
INFO[TYPE.approved] = { color: '#17a08c', label: 'Accepted' };
INFO[TYPE.rejected] = { color: '#D8DBDE', label: 'Not Accepted' };

INFO.forEach(function (info, index) {
  info.deletable = index === TYPE.incomplete;
  info.editable = index <= TYPE.incomplete;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  getInfo: function getInfo(submissionStatus) {
    return INFO[TYPE[submissionStatus]];
  },

  TYPE: TYPE,
  INFO: INFO
});

/***/ })

},[202]);


// WEBPACK FOOTER //
// js/app.2c27eae5f33ab3127b38.js